﻿export const library = [
  {
    "id": "divine-synthesis-en-pdf",
    "title": {
      "en": "Divine Synthesis",
      "es": "Síntesis Divina",
      "nl": "Goddelijke Synthese",
      "pap": "Síntesis Divino"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Divine Synthesis.",
      "es": "Documento PDF para Divine Synthesis.",
      "nl": "PDF-document voor Divine Synthesis.",
      "pap": "Dokumento PDF pa Divine Synthesis."
    },
    "url": "./articles/Divine Synthesis.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "divine-synthesis-es-pdf",
    "title": {
      "en": "Divine Synthesis",
      "es": "Síntesis Divina",
      "nl": "Goddelijke Synthese",
      "pap": "Síntesis Divino"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Divine Synthesis.",
      "es": "Documento PDF para Divine Synthesis.",
      "nl": "PDF-document voor Divine Synthesis.",
      "pap": "Dokumento PDF pa Divine Synthesis."
    },
    "url": "./articles/Divine Synthesis_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "divine-synthesis-nl-pdf",
    "title": {
      "en": "Divine Synthesis",
      "es": "Síntesis Divina",
      "nl": "Goddelijke Synthese",
      "pap": "Síntesis Divino"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Divine Synthesis.",
      "es": "Documento PDF para Divine Synthesis.",
      "nl": "PDF-document voor Divine Synthesis.",
      "pap": "Dokumento PDF pa Divine Synthesis."
    },
    "url": "./articles/Divine Synthesis_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "universal-base-directives-the-three-pillars-en-pdf",
    "title": {
      "en": "Universal Base Directives: The Three Pillars",
      "es": "Directrices Base Universales: Los Tres Pilares",
      "nl": "Universele Basisrichtlijnen: De Drie Pijlers",
      "pap": "Direktivanan Base Universal: E Tres Pilarnan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Universal Base Directives: The Three Pillars.",
      "es": "Documento PDF para Universal Base Directives: The Three Pillars.",
      "nl": "PDF-document voor Universal Base Directives: The Three Pillars.",
      "pap": "Dokumento PDF pa Universal Base Directives: The Three Pillars."
    },
    "url": "./articles/Universal Base Directives.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "universal-base-directives-the-three-pillars-es-pdf",
    "title": {
      "en": "Universal Base Directives: The Three Pillars",
      "es": "Directrices Base Universales: Los Tres Pilares",
      "nl": "Universele Basisrichtlijnen: De Drie Pijlers",
      "pap": "Direktivanan Base Universal: E Tres Pilarnan"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Universal Base Directives: The Three Pillars.",
      "es": "Documento PDF para Universal Base Directives: The Three Pillars.",
      "nl": "PDF-document voor Universal Base Directives: The Three Pillars.",
      "pap": "Dokumento PDF pa Universal Base Directives: The Three Pillars."
    },
    "url": "./articles/Universal Base Directives_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "universal-base-directives-the-three-pillars-nl-pdf",
    "title": {
      "en": "Universal Base Directives: The Three Pillars",
      "es": "Directrices Base Universales: Los Tres Pilares",
      "nl": "Universele Basisrichtlijnen: De Drie Pijlers",
      "pap": "Direktivanan Base Universal: E Tres Pilarnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Universal Base Directives: The Three Pillars.",
      "es": "Documento PDF para Universal Base Directives: The Three Pillars.",
      "nl": "PDF-document voor Universal Base Directives: The Three Pillars.",
      "pap": "Dokumento PDF pa Universal Base Directives: The Three Pillars."
    },
    "url": "./articles/Universal Base Directives_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "to-live-is-to-die-to-die-is-to-be-reborn-en-pdf",
    "title": {
      "en": "To Live is to Die, to Die is to be Reborn",
      "es": "Vivir es Morir, Morir es Renacer",
      "nl": "Leven is Sterven, Sterven is Herboren Worden",
      "pap": "Biba ta Muri, Muri ta Nase di Nobo"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for To Live is to Die, to Die is to be Reborn.",
      "es": "Documento PDF para To Live is to Die, to Die is to be Reborn.",
      "nl": "PDF-document voor To Live is to Die, to Die is to be Reborn.",
      "pap": "Dokumento PDF pa To Live is to Die, to Die is to be Reborn."
    },
    "url": "./articles/To Live is to Die.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "to-live-is-to-die-to-die-is-to-be-reborn-es-pdf",
    "title": {
      "en": "To Live is to Die, to Die is to be Reborn",
      "es": "Vivir es Morir, Morir es Renacer",
      "nl": "Leven is Sterven, Sterven is Herboren Worden",
      "pap": "Biba ta Muri, Muri ta Nase di Nobo"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for To Live is to Die, to Die is to be Reborn.",
      "es": "Documento PDF para To Live is to Die, to Die is to be Reborn.",
      "nl": "PDF-document voor To Live is to Die, to Die is to be Reborn.",
      "pap": "Dokumento PDF pa To Live is to Die, to Die is to be Reborn."
    },
    "url": "./articles/To Live is to Die_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "to-live-is-to-die-to-die-is-to-be-reborn-nl-pdf",
    "title": {
      "en": "To Live is to Die, to Die is to be Reborn",
      "es": "Vivir es Morir, Morir es Renacer",
      "nl": "Leven is Sterven, Sterven is Herboren Worden",
      "pap": "Biba ta Muri, Muri ta Nase di Nobo"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for To Live is to Die, to Die is to be Reborn.",
      "es": "Documento PDF para To Live is to Die, to Die is to be Reborn.",
      "nl": "PDF-document voor To Live is to Die, to Die is to be Reborn.",
      "pap": "Dokumento PDF pa To Live is to Die, to Die is to be Reborn."
    },
    "url": "./articles/To Live is to Die_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "mjolnir-en-pdf",
    "title": {
      "en": "Mjölnir",
      "es": "Mjölnir",
      "nl": "Mjölnir",
      "pap": "Mjölnir"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Mjölnir.",
      "es": "Documento PDF para Mjölnir.",
      "nl": "PDF-document voor Mjölnir.",
      "pap": "Dokumento PDF pa Mjölnir."
    },
    "url": "./articles/Mjolnir-EN.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "mjolnir-es-pdf",
    "title": {
      "en": "Mjölnir",
      "es": "Mjölnir",
      "nl": "Mjölnir",
      "pap": "Mjölnir"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Mjölnir.",
      "es": "Documento PDF para Mjölnir.",
      "nl": "PDF-document voor Mjölnir.",
      "pap": "Dokumento PDF pa Mjölnir."
    },
    "url": "./articles/Mjolnir-ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "mjolnir-nl-pdf",
    "title": {
      "en": "Mjölnir",
      "es": "Mjölnir",
      "nl": "Mjölnir",
      "pap": "Mjölnir"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Mjölnir.",
      "es": "Documento PDF para Mjölnir.",
      "nl": "PDF-document voor Mjölnir.",
      "pap": "Dokumento PDF pa Mjölnir."
    },
    "url": "./articles/Mjolnir-NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-case-for-graven-and-molten-images-en-pdf",
    "title": {
      "en": "The Case for Graven & Molten Images",
      "es": "El Caso de las Imágenes Talladas y Fundidas",
      "nl": "Het Pleidooi voor Gesneden & Gegoten Beelden",
      "pap": "E Argumento pa Imágennan Kòrtá i Fundí"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Case for Graven & Molten Images.",
      "es": "Documento PDF para The Case for Graven & Molten Images.",
      "nl": "PDF-document voor The Case for Graven & Molten Images.",
      "pap": "Dokumento PDF pa The Case for Graven & Molten Images."
    },
    "url": "./articles/The Case For Graven Molten Images_EN.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-case-for-graven-and-molten-images-es-pdf",
    "title": {
      "en": "The Case for Graven & Molten Images",
      "es": "El Caso de las Imágenes Talladas y Fundidas",
      "nl": "Het Pleidooi voor Gesneden & Gegoten Beelden",
      "pap": "E Argumento pa Imágennan Kòrtá i Fundí"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Case for Graven & Molten Images.",
      "es": "Documento PDF para The Case for Graven & Molten Images.",
      "nl": "PDF-document voor The Case for Graven & Molten Images.",
      "pap": "Dokumento PDF pa The Case for Graven & Molten Images."
    },
    "url": "./articles/The Case For Graven Molten Images_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-case-for-graven-and-molten-images-nl-pdf",
    "title": {
      "en": "The Case for Graven & Molten Images",
      "es": "El Caso de las Imágenes Talladas y Fundidas",
      "nl": "Het Pleidooi voor Gesneden & Gegoten Beelden",
      "pap": "E Argumento pa Imágennan Kòrtá i Fundí"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Case for Graven & Molten Images.",
      "es": "Documento PDF para The Case for Graven & Molten Images.",
      "nl": "PDF-document voor The Case for Graven & Molten Images.",
      "pap": "Dokumento PDF pa The Case for Graven & Molten Images."
    },
    "url": "./articles/The Case For Graven Molten Images_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-electric-logos-en-pdf",
    "title": {
      "en": "The Electric Logos",
      "es": "El Logos Eléctrico",
      "nl": "De Elektrische Logos",
      "pap": "E Logos Elektriko"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Electric Logos.",
      "es": "Documento PDF para The Electric Logos.",
      "nl": "PDF-document voor The Electric Logos.",
      "pap": "Dokumento PDF pa The Electric Logos."
    },
    "url": "./articles/The Electric Logos_EN.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-electric-logos-es-pdf",
    "title": {
      "en": "The Electric Logos",
      "es": "El Logos Eléctrico",
      "nl": "De Elektrische Logos",
      "pap": "E Logos Elektriko"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Electric Logos.",
      "es": "Documento PDF para The Electric Logos.",
      "nl": "PDF-document voor The Electric Logos.",
      "pap": "Dokumento PDF pa The Electric Logos."
    },
    "url": "./articles/The Electric Logos_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-electric-logos-nl-pdf",
    "title": {
      "en": "The Electric Logos",
      "es": "El Logos Eléctrico",
      "nl": "De Elektrische Logos",
      "pap": "E Logos Elektriko"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Electric Logos.",
      "es": "Documento PDF para The Electric Logos.",
      "nl": "PDF-document voor The Electric Logos.",
      "pap": "Dokumento PDF pa The Electric Logos."
    },
    "url": "./articles/The Electric Logos_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "liber-555-en-pdf",
    "title": {
      "en": "Liber 555",
      "es": "Liber 555",
      "nl": "Liber 555",
      "pap": "Liber 555"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Liber 555.",
      "es": "Documento PDF para Liber 555.",
      "nl": "PDF-document voor Liber 555.",
      "pap": "Dokumento PDF pa Liber 555."
    },
    "url": "./articles/transitus-ad-libertatem-EN.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "liber-555-es-pdf",
    "title": {
      "en": "Liber 555",
      "es": "Liber 555",
      "nl": "Liber 555",
      "pap": "Liber 555"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Liber 555.",
      "es": "Documento PDF para Liber 555.",
      "nl": "PDF-document voor Liber 555.",
      "pap": "Dokumento PDF pa Liber 555."
    },
    "url": "./articles/transitus-ad-libertatem-ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "liber-555-nl-pdf",
    "title": {
      "en": "Liber 555",
      "es": "Liber 555",
      "nl": "Liber 555",
      "pap": "Liber 555"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Liber 555.",
      "es": "Documento PDF para Liber 555.",
      "nl": "PDF-document voor Liber 555.",
      "pap": "Dokumento PDF pa Liber 555."
    },
    "url": "./articles/transitus-ad-libertatem-NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-sacred-gift-of-beauty-en-pdf",
    "title": {
      "en": "The Sacred Gift of Beauty",
      "es": "El Sagrado Don de la Belleza",
      "nl": "Het Heilige Geschenk van Schoonheid",
      "pap": "E Don Sagrado di Beyesa"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Sacred Gift of Beauty.",
      "es": "Documento PDF para The Sacred Gift of Beauty.",
      "nl": "PDF-document voor The Sacred Gift of Beauty.",
      "pap": "Dokumento PDF pa The Sacred Gift of Beauty."
    },
    "url": "./articles/the-sacred-gift-of-beauty_EN.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-sacred-gift-of-beauty-es-pdf",
    "title": {
      "en": "The Sacred Gift of Beauty",
      "es": "El Sagrado Don de la Belleza",
      "nl": "Het Heilige Geschenk van Schoonheid",
      "pap": "E Don Sagrado di Beyesa"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Sacred Gift of Beauty.",
      "es": "Documento PDF para The Sacred Gift of Beauty.",
      "nl": "PDF-document voor The Sacred Gift of Beauty.",
      "pap": "Dokumento PDF pa The Sacred Gift of Beauty."
    },
    "url": "./articles/the-sacred-gift-of-beauty_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-sacred-gift-of-beauty-nl-pdf",
    "title": {
      "en": "The Sacred Gift of Beauty",
      "es": "El Sagrado Don de la Belleza",
      "nl": "Het Heilige Geschenk van Schoonheid",
      "pap": "E Don Sagrado di Beyesa"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Sacred Gift of Beauty.",
      "es": "Documento PDF para The Sacred Gift of Beauty.",
      "nl": "PDF-document voor The Sacred Gift of Beauty.",
      "pap": "Dokumento PDF pa The Sacred Gift of Beauty."
    },
    "url": "./articles/the-sacred-gift-of-beauty_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "sample-monograph-the-neteru-en-pdf",
    "title": {
      "en": "Sample Monograph: The Neteru",
      "es": "Monografía de Muestra: Los Neteru",
      "nl": "Voorbeeldmonografie: De Neteru",
      "pap": "Monografia di Muestra: E Neteru"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Sample Monograph: The Neteru.",
      "es": "Documento PDF para Sample Monograph: The Neteru.",
      "nl": "PDF-document voor Sample Monograph: The Neteru.",
      "pap": "Dokumento PDF pa Sample Monograph: The Neteru."
    },
    "url": "./articles/first-element-the-neteru-EN.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "sample-monograph-the-neteru-es-pdf",
    "title": {
      "en": "Sample Monograph: The Neteru",
      "es": "Monografía de Muestra: Los Neteru",
      "nl": "Voorbeeldmonografie: De Neteru",
      "pap": "Monografia di Muestra: E Neteru"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Sample Monograph: The Neteru.",
      "es": "Documento PDF para Sample Monograph: The Neteru.",
      "nl": "PDF-document voor Sample Monograph: The Neteru.",
      "pap": "Dokumento PDF pa Sample Monograph: The Neteru."
    },
    "url": "./articles/first-element-the-neteru-ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "sample-monograph-the-neteru-nl-pdf",
    "title": {
      "en": "Sample Monograph: The Neteru",
      "es": "Monografía de Muestra: Los Neteru",
      "nl": "Voorbeeldmonografie: De Neteru",
      "pap": "Monografia di Muestra: E Neteru"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Sample Monograph: The Neteru.",
      "es": "Documento PDF para Sample Monograph: The Neteru.",
      "nl": "PDF-document voor Sample Monograph: The Neteru.",
      "pap": "Dokumento PDF pa Sample Monograph: The Neteru."
    },
    "url": "./articles/first-element-the-neteru-NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-codex-of-eternity-from-the-djd-waw-the-first-speech-en-pdf",
    "title": {
      "en": "The Codex of Eternity: From the Djd Waw – The First Speech",
      "es": "The Codex of Eternity: Del Djd Waw – El Primer Discurso",
      "nl": "The Codex of Eternity: Uit de Djd Waw – De Eerste Toespraak",
      "pap": "The Codex of Eternity: For di e Djd Waw – E Promé Diskurso"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Codex of Eternity: From the Djd Waw – The First Speech.",
      "es": "Documento PDF para The Codex of Eternity: From the Djd Waw – The First Speech.",
      "nl": "PDF-document voor The Codex of Eternity: From the Djd Waw – The First Speech.",
      "pap": "Dokumento PDF pa The Codex of Eternity: From the Djd Waw – The First Speech."
    },
    "url": "./articles/Shfdw Tawrt - 0. Codex of Eternity-EN.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-codex-of-eternity-from-the-djd-waw-the-first-speech-es-pdf",
    "title": {
      "en": "The Codex of Eternity: From the Djd Waw – The First Speech",
      "es": "The Codex of Eternity: Del Djd Waw – El Primer Discurso",
      "nl": "The Codex of Eternity: Uit de Djd Waw – De Eerste Toespraak",
      "pap": "The Codex of Eternity: For di e Djd Waw – E Promé Diskurso"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Codex of Eternity: From the Djd Waw – The First Speech.",
      "es": "Documento PDF para The Codex of Eternity: From the Djd Waw – The First Speech.",
      "nl": "PDF-document voor The Codex of Eternity: From the Djd Waw – The First Speech.",
      "pap": "Dokumento PDF pa The Codex of Eternity: From the Djd Waw – The First Speech."
    },
    "url": "./articles/Shfdw Tawrt - 0. Codex of Eternity-ES.pdf",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-codex-of-eternity-from-the-djd-waw-the-first-speech-nl-pdf",
    "title": {
      "en": "The Codex of Eternity: From the Djd Waw – The First Speech",
      "es": "The Codex of Eternity: Del Djd Waw – El Primer Discurso",
      "nl": "The Codex of Eternity: Uit de Djd Waw – De Eerste Toespraak",
      "pap": "The Codex of Eternity: For di e Djd Waw – E Promé Diskurso"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Codex of Eternity: From the Djd Waw – The First Speech.",
      "es": "Documento PDF para The Codex of Eternity: From the Djd Waw – The First Speech.",
      "nl": "PDF-document voor The Codex of Eternity: From the Djd Waw – The First Speech.",
      "pap": "Dokumento PDF pa The Codex of Eternity: From the Djd Waw – The First Speech."
    },
    "url": "./articles/Shfdw Tawrt - 0. Codex of Eternity-NL.pdf",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "understanding-law-there-are-no-human-laws-only-eternal-principles-governing-reality-en-pdf",
    "title": {
      "en": "Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality",
      "es": "Entender la Ley: No Existen Leyes Humanas, Solo Principios Eternos que Rigen la Realidad",
      "nl": "De Wet Begrijpen: Er Zijn Geen Menselijke Wetten, Alleen Eeuwige Principes die de Werkelijkheid Besturen",
      "pap": "Komprondé Lei: No Tin Lei Humano, Solamente Prinsipionan Eterno ku ta Goberná Realidat"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality.",
      "es": "Documento PDF para Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality.",
      "nl": "PDF-document voor Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality.",
      "pap": "Dokumento PDF pa Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality."
    },
    "url": "./articles/understanding-law-EN.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "understanding-law-there-are-no-human-laws-only-eternal-principles-governing-reality-es-pdf",
    "title": {
      "en": "Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality",
      "es": "Entender la Ley: No Existen Leyes Humanas, Solo Principios Eternos que Rigen la Realidad",
      "nl": "De Wet Begrijpen: Er Zijn Geen Menselijke Wetten, Alleen Eeuwige Principes die de Werkelijkheid Besturen",
      "pap": "Komprondé Lei: No Tin Lei Humano, Solamente Prinsipionan Eterno ku ta Goberná Realidat"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality.",
      "es": "Documento PDF para Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality.",
      "nl": "PDF-document voor Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality.",
      "pap": "Dokumento PDF pa Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality."
    },
    "url": "./articles/understanding-law-ES.pdf",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "understanding-law-there-are-no-human-laws-only-eternal-principles-governing-reality-nl-pdf",
    "title": {
      "en": "Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality",
      "es": "Entender la Ley: No Existen Leyes Humanas, Solo Principios Eternos que Rigen la Realidad",
      "nl": "De Wet Begrijpen: Er Zijn Geen Menselijke Wetten, Alleen Eeuwige Principes die de Werkelijkheid Besturen",
      "pap": "Komprondé Lei: No Tin Lei Humano, Solamente Prinsipionan Eterno ku ta Goberná Realidat"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality.",
      "es": "Documento PDF para Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality.",
      "nl": "PDF-document voor Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality.",
      "pap": "Dokumento PDF pa Understanding Law: There Are No Human Laws, Only Eternal Principles Governing Reality."
    },
    "url": "./articles/understanding-law-NL.pdf",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "freedom-the-divine-elixir-of-harmony-en-pdf",
    "title": {
      "en": "Freedom - The Divine Elixir of Harmony",
      "es": "Libertad - El Divino Elixir de la Armonía",
      "nl": "Vrijheid - Het Goddelijke Elixir van Harmonie",
      "pap": "Libertat - E Eliksir Divino di Armonia"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Freedom - The Divine Elixir of Harmony.",
      "es": "Documento PDF para Freedom - The Divine Elixir of Harmony.",
      "nl": "PDF-document voor Freedom - The Divine Elixir of Harmony.",
      "pap": "Dokumento PDF pa Freedom - The Divine Elixir of Harmony."
    },
    "url": "./articles/Freedom - the divine exilir of harmonyv3.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "freedom-the-divine-elixir-of-harmony-es-pdf",
    "title": {
      "en": "Freedom - The Divine Elixir of Harmony",
      "es": "Libertad - El Divino Elixir de la Armonía",
      "nl": "Vrijheid - Het Goddelijke Elixir van Harmonie",
      "pap": "Libertat - E Eliksir Divino di Armonia"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Freedom - The Divine Elixir of Harmony.",
      "es": "Documento PDF para Freedom - The Divine Elixir of Harmony.",
      "nl": "PDF-document voor Freedom - The Divine Elixir of Harmony.",
      "pap": "Dokumento PDF pa Freedom - The Divine Elixir of Harmony."
    },
    "url": "./articles/Freedom - the divine exilir of harmonyv3_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "freedom-the-divine-elixir-of-harmony-nl-pdf",
    "title": {
      "en": "Freedom - The Divine Elixir of Harmony",
      "es": "Libertad - El Divino Elixir de la Armonía",
      "nl": "Vrijheid - Het Goddelijke Elixir van Harmonie",
      "pap": "Libertat - E Eliksir Divino di Armonia"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Freedom - The Divine Elixir of Harmony.",
      "es": "Documento PDF para Freedom - The Divine Elixir of Harmony.",
      "nl": "PDF-document voor Freedom - The Divine Elixir of Harmony.",
      "pap": "Dokumento PDF pa Freedom - The Divine Elixir of Harmony."
    },
    "url": "./articles/Freedom - the divine exilir of harmonyv3_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "lord-of-the-elements-son-of-the-sun-en-pdf",
    "title": {
      "en": "Lord of the Elements - Son of the Sun",
      "es": "Señor de los Elementos - Hijo del Sol",
      "nl": "Heer van de Elementen - Zoon van de Zon",
      "pap": "Señor di e Elementonan - Yu di Solo"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Lord of the Elements - Son of the Sun.",
      "es": "Documento PDF para Lord of the Elements - Son of the Sun.",
      "nl": "PDF-document voor Lord of the Elements - Son of the Sun.",
      "pap": "Dokumento PDF pa Lord of the Elements - Son of the Sun."
    },
    "url": "./articles/Lord of the Elements - Son of the Sunv3.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "lord-of-the-elements-son-of-the-sun-es-pdf",
    "title": {
      "en": "Lord of the Elements - Son of the Sun",
      "es": "Señor de los Elementos - Hijo del Sol",
      "nl": "Heer van de Elementen - Zoon van de Zon",
      "pap": "Señor di e Elementonan - Yu di Solo"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Lord of the Elements - Son of the Sun.",
      "es": "Documento PDF para Lord of the Elements - Son of the Sun.",
      "nl": "PDF-document voor Lord of the Elements - Son of the Sun.",
      "pap": "Dokumento PDF pa Lord of the Elements - Son of the Sun."
    },
    "url": "./articles/Lord of the Elements - Son of the Sunv3_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "lord-of-the-elements-son-of-the-sun-nl-pdf",
    "title": {
      "en": "Lord of the Elements - Son of the Sun",
      "es": "Señor de los Elementos - Hijo del Sol",
      "nl": "Heer van de Elementen - Zoon van de Zon",
      "pap": "Señor di e Elementonan - Yu di Solo"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for Lord of the Elements - Son of the Sun.",
      "es": "Documento PDF para Lord of the Elements - Son of the Sun.",
      "nl": "PDF-document voor Lord of the Elements - Son of the Sun.",
      "pap": "Dokumento PDF pa Lord of the Elements - Son of the Sun."
    },
    "url": "./articles/Lord of the Elements - Son of the Sunv3_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-suppression-of-the-divine-feminine-force-en-pdf",
    "title": {
      "en": "The Suppression of the Divine Feminine Force",
      "es": "La Supresión de la Fuerza Femenina Divina",
      "nl": "De Onderdrukking van de Goddelijke Vrouwelijke Kracht",
      "pap": "E Supreshon di e Forsa Femenino Divino"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Suppression of the Divine Feminine Force.",
      "es": "Documento PDF para The Suppression of the Divine Feminine Force.",
      "nl": "PDF-document voor The Suppression of the Divine Feminine Force.",
      "pap": "Dokumento PDF pa The Suppression of the Divine Feminine Force."
    },
    "url": "./articles/The Suppression of the Divine Feminine Forcev3.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-suppression-of-the-divine-feminine-force-es-pdf",
    "title": {
      "en": "The Suppression of the Divine Feminine Force",
      "es": "La Supresión de la Fuerza Femenina Divina",
      "nl": "De Onderdrukking van de Goddelijke Vrouwelijke Kracht",
      "pap": "E Supreshon di e Forsa Femenino Divino"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Suppression of the Divine Feminine Force.",
      "es": "Documento PDF para The Suppression of the Divine Feminine Force.",
      "nl": "PDF-document voor The Suppression of the Divine Feminine Force.",
      "pap": "Dokumento PDF pa The Suppression of the Divine Feminine Force."
    },
    "url": "./articles/The Suppression of the Divine Feminine Forcev3_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-suppression-of-the-divine-feminine-force-nl-pdf",
    "title": {
      "en": "The Suppression of the Divine Feminine Force",
      "es": "La Supresión de la Fuerza Femenina Divina",
      "nl": "De Onderdrukking van de Goddelijke Vrouwelijke Kracht",
      "pap": "E Supreshon di e Forsa Femenino Divino"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The Suppression of the Divine Feminine Force.",
      "es": "Documento PDF para The Suppression of the Divine Feminine Force.",
      "nl": "PDF-document voor The Suppression of the Divine Feminine Force.",
      "pap": "Dokumento PDF pa The Suppression of the Divine Feminine Force."
    },
    "url": "./articles/The Suppression of the Divine Feminine Forcev3_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "on-the-purpose-of-humanity-on-earth-en-pdf",
    "title": {
      "en": "On the Purpose of Humanity on Earth",
      "es": "Sobre el Propósito de la Humanidad en la Tierra",
      "nl": "Over het Doel van de Mensheid op Aarde",
      "pap": "Tokante e Propósito di Humanidat riba Tera"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for On the Purpose of Humanity on Earth.",
      "es": "Documento PDF para On the Purpose of Humanity on Earth.",
      "nl": "PDF-document voor On the Purpose of Humanity on Earth.",
      "pap": "Dokumento PDF pa On the Purpose of Humanity on Earth."
    },
    "url": "./articles/On the Purpose of Humanity on Earth.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "on-the-purpose-of-humanity-on-earth-es-pdf",
    "title": {
      "en": "On the Purpose of Humanity on Earth",
      "es": "Sobre el Propósito de la Humanidad en la Tierra",
      "nl": "Over het Doel van de Mensheid op Aarde",
      "pap": "Tokante e Propósito di Humanidat riba Tera"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for On the Purpose of Humanity on Earth.",
      "es": "Documento PDF para On the Purpose of Humanity on Earth.",
      "nl": "PDF-document voor On the Purpose of Humanity on Earth.",
      "pap": "Dokumento PDF pa On the Purpose of Humanity on Earth."
    },
    "url": "./articles/On the Purpose of Humanity On Earth_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "on-the-purpose-of-humanity-on-earth-nl-pdf",
    "title": {
      "en": "On the Purpose of Humanity on Earth",
      "es": "Sobre el Propósito de la Humanidad en la Tierra",
      "nl": "Over het Doel van de Mensheid op Aarde",
      "pap": "Tokante e Propósito di Humanidat riba Tera"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for On the Purpose of Humanity on Earth.",
      "es": "Documento PDF para On the Purpose of Humanity on Earth.",
      "nl": "PDF-document voor On the Purpose of Humanity on Earth.",
      "pap": "Dokumento PDF pa On the Purpose of Humanity on Earth."
    },
    "url": "./articles/On the Purpose of Humanity On Earth_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-states-of-consciousness-in-the-evolution-of-men-en-pdf",
    "title": {
      "en": "The States of Consciousness in the Evolution of Men",
      "es": "Los Estados de Conciencia en la Evolución del Hombre",
      "nl": "De Bewustzijnstoestanden in de Evolutie van de Mens",
      "pap": "E Estadonan di Konsenshi den e Evolushon di Hende"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The States of Consciousness in the Evolution of Men.",
      "es": "Documento PDF para The States of Consciousness in the Evolution of Men.",
      "nl": "PDF-document voor The States of Consciousness in the Evolution of Men.",
      "pap": "Dokumento PDF pa The States of Consciousness in the Evolution of Men."
    },
    "url": "./articles/The States Of Consciousness-1177.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-states-of-consciousness-in-the-evolution-of-men-es-pdf",
    "title": {
      "en": "The States of Consciousness in the Evolution of Men",
      "es": "Los Estados de Conciencia en la Evolución del Hombre",
      "nl": "De Bewustzijnstoestanden in de Evolutie van de Mens",
      "pap": "E Estadonan di Konsenshi den e Evolushon di Hende"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The States of Consciousness in the Evolution of Men.",
      "es": "Documento PDF para The States of Consciousness in the Evolution of Men.",
      "nl": "PDF-document voor The States of Consciousness in the Evolution of Men.",
      "pap": "Dokumento PDF pa The States of Consciousness in the Evolution of Men."
    },
    "url": "./articles/The States Of Consciousness-1177_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "the-states-of-consciousness-in-the-evolution-of-men-nl-pdf",
    "title": {
      "en": "The States of Consciousness in the Evolution of Men",
      "es": "Los Estados de Conciencia en la Evolución del Hombre",
      "nl": "De Bewustzijnstoestanden in de Evolutie van de Mens",
      "pap": "E Estadonan di Konsenshi den e Evolushon di Hende"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for The States of Consciousness in the Evolution of Men.",
      "es": "Documento PDF para The States of Consciousness in the Evolution of Men.",
      "nl": "PDF-document voor The States of Consciousness in the Evolution of Men.",
      "pap": "Dokumento PDF pa The States of Consciousness in the Evolution of Men."
    },
    "url": "./articles/The States Of Consciousness-1177_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "a-small-discourse-on-the-immutability-of-natural-laws-en-pdf",
    "title": {
      "en": "A Small Discourse on the Immutability of Natural Laws",
      "es": "Un Pequeño Discurso sobre la Inmutabilidad de las Leyes Naturales",
      "nl": "Een Klein Betoog over de Onveranderlijkheid van Natuurwetten",
      "pap": "Un Diskurso Chikitu tokante e Inmutabilidat di Leinan Natural"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for A Small Discourse on the Immutability of Natural Laws.",
      "es": "Documento PDF para A Small Discourse on the Immutability of Natural Laws.",
      "nl": "PDF-document voor A Small Discourse on the Immutability of Natural Laws.",
      "pap": "Dokumento PDF pa A Small Discourse on the Immutability of Natural Laws."
    },
    "url": "./articles/A Discourse on the Immutability of Natural Laws.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "a-small-discourse-on-the-immutability-of-natural-laws-es-pdf",
    "title": {
      "en": "A Small Discourse on the Immutability of Natural Laws",
      "es": "Un Pequeño Discurso sobre la Inmutabilidad de las Leyes Naturales",
      "nl": "Een Klein Betoog over de Onveranderlijkheid van Natuurwetten",
      "pap": "Un Diskurso Chikitu tokante e Inmutabilidat di Leinan Natural"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for A Small Discourse on the Immutability of Natural Laws.",
      "es": "Documento PDF para A Small Discourse on the Immutability of Natural Laws.",
      "nl": "PDF-document voor A Small Discourse on the Immutability of Natural Laws.",
      "pap": "Dokumento PDF pa A Small Discourse on the Immutability of Natural Laws."
    },
    "url": "./articles/A Discourse on the Immutability of Natural Laws_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "a-small-discourse-on-the-immutability-of-natural-laws-nl-pdf",
    "title": {
      "en": "A Small Discourse on the Immutability of Natural Laws",
      "es": "Un Pequeño Discurso sobre la Inmutabilidad de las Leyes Naturales",
      "nl": "Een Klein Betoog over de Onveranderlijkheid van Natuurwetten",
      "pap": "Un Diskurso Chikitu tokante e Inmutabilidat di Leinan Natural"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for A Small Discourse on the Immutability of Natural Laws.",
      "es": "Documento PDF para A Small Discourse on the Immutability of Natural Laws.",
      "nl": "PDF-document voor A Small Discourse on the Immutability of Natural Laws.",
      "pap": "Dokumento PDF pa A Small Discourse on the Immutability of Natural Laws."
    },
    "url": "./articles/A Discourse on the Immutability of Natural Laws_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "on-the-purpose-of-humanity-in-the-universe-en-pdf",
    "title": {
      "en": "On the Purpose of Humanity in the Universe",
      "es": "Sobre el Propósito de la Humanidad en el Universo",
      "nl": "Over het Doel van de Mensheid in het Universum",
      "pap": "Tokante e Propósito di Humanidat den e Universo"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for On the Purpose of Humanity in the Universe.",
      "es": "Documento PDF para On the Purpose of Humanity in the Universe.",
      "nl": "PDF-document voor On the Purpose of Humanity in the Universe.",
      "pap": "Dokumento PDF pa On the Purpose of Humanity in the Universe."
    },
    "url": "./articles/On The Purpose of Humanity in the Universe.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "on-the-purpose-of-humanity-in-the-universe-es-pdf",
    "title": {
      "en": "On the Purpose of Humanity in the Universe",
      "es": "Sobre el Propósito de la Humanidad en el Universo",
      "nl": "Over het Doel van de Mensheid in het Universum",
      "pap": "Tokante e Propósito di Humanidat den e Universo"
    },
    "type": "pdf",
    "language": "es",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for On the Purpose of Humanity in the Universe.",
      "es": "Documento PDF para On the Purpose of Humanity in the Universe.",
      "nl": "PDF-document voor On the Purpose of Humanity in the Universe.",
      "pap": "Dokumento PDF pa On the Purpose of Humanity in the Universe."
    },
    "url": "./articles/On The Purpose of Humanity in the Universe_ES.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "on-the-purpose-of-humanity-in-the-universe-nl-pdf",
    "title": {
      "en": "On the Purpose of Humanity in the Universe",
      "es": "Sobre el Propósito de la Humanidad en el Universo",
      "nl": "Over het Doel van de Mensheid in het Universum",
      "pap": "Tokante e Propósito di Humanidat den e Universo"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "en",
      "es",
      "nl"
    ],
    "description": {
      "en": "PDF document for On the Purpose of Humanity in the Universe.",
      "es": "Documento PDF para On the Purpose of Humanity in the Universe.",
      "nl": "PDF-document voor On the Purpose of Humanity in the Universe.",
      "pap": "Dokumento PDF pa On the Purpose of Humanity in the Universe."
    },
    "url": "./articles/On The Purpose of Humanity in the Universe_NL.pdf#toolbar=0",
    "category": "articles",
    "relatedProgram": null,
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s1e1-de-7-principes-voor-een-morele-samenleving-waarheid-55",
    "title": {
      "en": "Eigen Pad S1E1 - The 7 Principles of a Moral Society - Truth",
      "es": "Eigen Pad S1E1 - Los 7 Principios de una Sociedad Moral - Verdad",
      "nl": "Eigen Pad S1E1 - De 7 Principes voor een Morele Samenleving - Waarheid",
      "pap": "Eigen Pad S1E1 - E 7 Prinsipionan di un Sosiedat Moral - Bèrdat"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S1E1 - De 7 Principes voor een Morele Samenleving - Waarheid.",
      "es": "Documento PDF para Eigen Pad S1E1 - De 7 Principes voor een Morele Samenleving - Waarheid.",
      "nl": "PDF-document voor Eigen Pad S1E1 - De 7 Principes voor een Morele Samenleving - Waarheid.",
      "pap": "Dokumento PDF pa Eigen Pad S1E1 - De 7 Principes voor een Morele Samenleving - Waarheid."
    },
    "url": "./media/Seizoen 1E1-Waarheid.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s1e2-de-7-principes-voor-een-morele-samenleving-gerechtigheid-56",
    "title": {
      "en": "Eigen Pad S1E2 - The 7 Principles of a Moral Society - Justice",
      "es": "Eigen Pad S1E2 - Los 7 Principios de una Sociedad Moral - Justicia",
      "nl": "Eigen Pad S1E2 - De 7 Principes voor een Morele Samenleving - Gerechtigheid",
      "pap": "Eigen Pad S1E2 - E 7 Prinsipionan di un Sosiedat Moral - Hustisia"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S1E2 - De 7 Principes voor een Morele Samenleving - Gerechtigheid.",
      "es": "Documento PDF para Eigen Pad S1E2 - De 7 Principes voor een Morele Samenleving - Gerechtigheid.",
      "nl": "PDF-document voor Eigen Pad S1E2 - De 7 Principes voor een Morele Samenleving - Gerechtigheid.",
      "pap": "Dokumento PDF pa Eigen Pad S1E2 - De 7 Principes voor een Morele Samenleving - Gerechtigheid."
    },
    "url": "./media/Seizoen 1E2-Gerechtigheid.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s1e3-de-7-principes-voor-een-morele-samenleving-harmonie-57",
    "title": {
      "en": "Eigen Pad S1E3 - The 7 Principles of a Moral Society - Harmony",
      "es": "Eigen Pad S1E3 - Los 7 Principios de una Sociedad Moral - Armonía",
      "nl": "Eigen Pad S1E3 - De 7 Principes voor een Morele Samenleving - Harmonie",
      "pap": "Eigen Pad S1E3 - E 7 Prinsipionan di un Sosiedat Moral - Armonia"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S1E3 - De 7 Principes voor een Morele Samenleving - Harmonie.",
      "es": "Documento PDF para Eigen Pad S1E3 - De 7 Principes voor een Morele Samenleving - Harmonie.",
      "nl": "PDF-document voor Eigen Pad S1E3 - De 7 Principes voor een Morele Samenleving - Harmonie.",
      "pap": "Dokumento PDF pa Eigen Pad S1E3 - De 7 Principes voor een Morele Samenleving - Harmonie."
    },
    "url": "./media/Seizoen 1E3-Harmonie.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s1e4-de-7-principes-voor-een-morele-samenleving-evenwicht-58",
    "title": {
      "en": "Eigen Pad S1E4 - The 7 Principles of a Moral Society - Balance",
      "es": "Eigen Pad S1E4 - Los 7 Principios de una Sociedad Moral - Equilibrio",
      "nl": "Eigen Pad S1E4 - De 7 Principes voor een Morele Samenleving - Evenwicht",
      "pap": "Eigen Pad S1E4 - E 7 Prinsipionan di un Sosiedat Moral - Balansa"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S1E4 - De 7 Principes voor een Morele Samenleving - Evenwicht.",
      "es": "Documento PDF para Eigen Pad S1E4 - De 7 Principes voor een Morele Samenleving - Evenwicht.",
      "nl": "PDF-document voor Eigen Pad S1E4 - De 7 Principes voor een Morele Samenleving - Evenwicht.",
      "pap": "Dokumento PDF pa Eigen Pad S1E4 - De 7 Principes voor een Morele Samenleving - Evenwicht."
    },
    "url": "./media/Seizoen 1E4-Evenwicht.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s1e5-de-7-principes-voor-een-morele-samenleving-speciale-aflevering-orde-met-uitleg-va-59",
    "title": {
      "en": "Eigen Pad S1E5 - The 7 Principles of a Moral Society - Special Episode: Order, with an explanation of 'The Great Reset'",
      "es": "Eigen Pad S1E5 - Los 7 Principios de una Sociedad Moral - Episodio Especial: Orden, con una explicación de 'The Great Reset'",
      "nl": "Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'",
      "pap": "Eigen Pad S1E5 - E 7 Prinsipionan di un Sosiedat Moral - Episodio Spesial: Òrden, ku un splikashon di 'The Great Reset'"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'.",
      "es": "Documento PDF para Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'.",
      "nl": "PDF-document voor Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'.",
      "pap": "Dokumento PDF pa Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'."
    },
    "url": "./media/Seizoen 1E5-Orde.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s1e5-de-7-principes-voor-een-morele-samenleving-speciale-aflevering-orde-met-uitleg-va-60",
    "title": {
      "en": "Eigen Pad S1E5 - The 7 Principles of a Moral Society - Special Episode: Order, with an explanation of 'The Great Reset'",
      "es": "Eigen Pad S1E5 - Los 7 Principios de una Sociedad Moral - Episodio Especial: Orden, con una explicación de 'The Great Reset'",
      "nl": "Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'",
      "pap": "Eigen Pad S1E5 - E 7 Prinsipionan di un Sosiedat Moral - Episodio Spesial: Òrden, ku un splikashon di 'The Great Reset'"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'.",
      "es": "Documento PDF para Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'.",
      "nl": "PDF-document voor Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'.",
      "pap": "Dokumento PDF pa Eigen Pad S1E5 - De 7 Principes voor een Morele Samenleving - Speciale Aflevering: Orde met uitleg van 'The Great Reset'."
    },
    "url": "./media/Kybalion.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s1e6-de-7-principes-voor-een-morele-samenleving-wederkerigheid-61",
    "title": {
      "en": "Eigen Pad S1E6 - The 7 Principles of a Moral Society - Reciprocity",
      "es": "Eigen Pad S1E6 - Los 7 Principios de una Sociedad Moral - Reciprocidad",
      "nl": "Eigen Pad S1E6 - De 7 Principes voor een Morele Samenleving - Wederkerigheid",
      "pap": "Eigen Pad S1E6 - E 7 Prinsipionan di un Sosiedat Moral - Resiprosidat"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S1E6 - De 7 Principes voor een Morele Samenleving - Wederkerigheid.",
      "es": "Documento PDF para Eigen Pad S1E6 - De 7 Principes voor een Morele Samenleving - Wederkerigheid.",
      "nl": "PDF-document voor Eigen Pad S1E6 - De 7 Principes voor een Morele Samenleving - Wederkerigheid.",
      "pap": "Dokumento PDF pa Eigen Pad S1E6 - De 7 Principes voor een Morele Samenleving - Wederkerigheid."
    },
    "url": "./media/Seizoen 1E6-Wederkerigheid.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s1e7-de-7-principes-voor-een-morele-samenleving-fatsoen-62",
    "title": {
      "en": "Eigen Pad S1E7 - The 7 Principles of a Moral Society - Decency",
      "es": "Eigen Pad S1E7 - Los 7 Principios de una Sociedad Moral - Decencia",
      "nl": "Eigen Pad S1E7 - De 7 Principes voor een Morele Samenleving - Fatsoen",
      "pap": "Eigen Pad S1E7 - E 7 Prinsipionan di un Sosiedat Moral - Desensia"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S1E7 - De 7 Principes voor een Morele Samenleving - Fatsoen.",
      "es": "Documento PDF para Eigen Pad S1E7 - De 7 Principes voor een Morele Samenleving - Fatsoen.",
      "nl": "PDF-document voor Eigen Pad S1E7 - De 7 Principes voor een Morele Samenleving - Fatsoen.",
      "pap": "Dokumento PDF pa Eigen Pad S1E7 - De 7 Principes voor een Morele Samenleving - Fatsoen."
    },
    "url": "./media/Seizoen 1E7-Fatsoen.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s1e8-interview-met-matt-landman-63",
    "title": {
      "en": "Eigen Pad S1E8 - Interview with Matt Landman",
      "es": "Eigen Pad S1E8 - Entrevista con Matt Landman",
      "nl": "Eigen Pad S1E8 - Interview met Matt Landman",
      "pap": "Eigen Pad S1E8 - Entrevista ku Matt Landman"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S1E8 - Interview met Matt Landman.",
      "es": "Documento PDF para Eigen Pad S1E8 - Interview met Matt Landman.",
      "nl": "PDF-document voor Eigen Pad S1E8 - Interview met Matt Landman.",
      "pap": "Dokumento PDF pa Eigen Pad S1E8 - Interview met Matt Landman."
    },
    "url": "./media/Seizoen 1E8-Bonus.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s2e1-deel-1-de-matrix-gedecodeerd-wat-is-de-matrix-64",
    "title": {
      "en": "Eigen Pad S2E1/Part 1 - The Matrix Decoded: What Is The Matrix?",
      "es": "Eigen Pad S2E1/Parte 1 - La Matrix Decodificada: ¿Qué Es La Matrix?",
      "nl": "Eigen Pad S2E1/Deel 1 - De Matrix Gedecodeerd: Wat Is De Matrix?",
      "pap": "Eigen Pad S2E1/Parti 1 - E Matrix Dekodifiká: Kiko Ta E Matrix?"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S2E1/Deel 1 - De Matrix Gedecodeerd: Wat Is De Matrix?.",
      "es": "Documento PDF para Eigen Pad S2E1/Deel 1 - De Matrix Gedecodeerd: Wat Is De Matrix?.",
      "nl": "PDF-document voor Eigen Pad S2E1/Deel 1 - De Matrix Gedecodeerd: Wat Is De Matrix?.",
      "pap": "Dokumento PDF pa Eigen Pad S2E1/Deel 1 - De Matrix Gedecodeerd: Wat Is De Matrix?."
    },
    "url": "./media/Seizoen-2E1-Wat-Is-De-Matrix-P1.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s2e4-de-matrix-gedecodeerd-waarom-zijn-we-in-de-matrix-65",
    "title": {
      "en": "Eigen Pad S2E4 - The Matrix Decoded: Why Are We In The Matrix",
      "es": "Eigen Pad S2E4 - La Matrix Decodificada: Por Qué Estamos En La Matrix",
      "nl": "Eigen Pad S2E4 - De Matrix Gedecodeerd: Waarom Zijn We In De Matrix",
      "pap": "Eigen Pad S2E4 - E Matrix Dekodifiká: Dikon Nos Ta Den E Matrix"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S2E4 - De Matrix Gedecodeerd: Waarom Zijn We In De Matrix.",
      "es": "Documento PDF para Eigen Pad S2E4 - De Matrix Gedecodeerd: Waarom Zijn We In De Matrix.",
      "nl": "PDF-document voor Eigen Pad S2E4 - De Matrix Gedecodeerd: Waarom Zijn We In De Matrix.",
      "pap": "Dokumento PDF pa Eigen Pad S2E4 - De Matrix Gedecodeerd: Waarom Zijn We In De Matrix."
    },
    "url": "./media/Seizoen-2E4-Waarom-Zijn-We-In-De-Matrix.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s2e7-de-matrix-gedecodeerd-hoe-komen-we-uit-de-matrix-66",
    "title": {
      "en": "Eigen Pad S2E7 - The Matrix Decoded: How Do We Get Out Of The Matrix",
      "es": "Eigen Pad S2E7 - La Matrix Decodificada: Cómo Salimos De La Matrix",
      "nl": "Eigen Pad S2E7 - De Matrix Gedecodeerd: Hoe Komen We Uit De Matrix",
      "pap": "Eigen Pad S2E7 - E Matrix Dekodifiká: Kon Nos Ta Sali For Di E Matrix"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S2E7 - De Matrix Gedecodeerd: Hoe Komen We Uit De Matrix.",
      "es": "Documento PDF para Eigen Pad S2E7 - De Matrix Gedecodeerd: Hoe Komen We Uit De Matrix.",
      "nl": "PDF-document voor Eigen Pad S2E7 - De Matrix Gedecodeerd: Hoe Komen We Uit De Matrix.",
      "pap": "Dokumento PDF pa Eigen Pad S2E7 - De Matrix Gedecodeerd: Hoe Komen We Uit De Matrix."
    },
    "url": "./media/Seizoen-2E7-Hoe-Komen-We-Uit-De-Matrix.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s2e8-de-matrix-gedecodeerd-wat-betekent-om-wakker-te-zijn-67",
    "title": {
      "en": "Eigen Pad S2E8 - The Matrix Decoded: What It Means To Be \"Awake\"",
      "es": "Eigen Pad S2E8 - La Matrix Decodificada: Qué Significa Estar \"Despierto\"",
      "nl": "Eigen Pad S2E8 - De Matrix Gedecodeerd: Wat Betekent Om \"Wakker\" te Zijn",
      "pap": "Eigen Pad S2E8 - E Matrix Dekodifiká: Kiko Ta Nifiká Ta \"Lantá\""
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S2E8 - De Matrix Gedecodeerd: Wat Betekent Om \"Wakker\" te Zijn.",
      "es": "Documento PDF para Eigen Pad S2E8 - De Matrix Gedecodeerd: Wat Betekent Om \"Wakker\" te Zijn.",
      "nl": "PDF-document voor Eigen Pad S2E8 - De Matrix Gedecodeerd: Wat Betekent Om \"Wakker\" te Zijn.",
      "pap": "Dokumento PDF pa Eigen Pad S2E8 - De Matrix Gedecodeerd: Wat Betekent Om \"Wakker\" te Zijn."
    },
    "url": "./media/Seizoen-2E8-Wat-Betekent-Ontwaakt-Zijn.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s2e10-deel-1-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel-68",
    "title": {
      "en": "Eigen Pad S2E10/Part 1 - The Matrix Decoded: Who Are You? What Is Your Purpose?",
      "es": "Eigen Pad S2E10/Parte 1 - La Matrix Decodificada: ¿Quién Eres? ¿Cuál Es Tu Propósito?",
      "nl": "Eigen Pad S2E10/Deel 1 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?",
      "pap": "Eigen Pad S2E10/Parti 1 - E Matrix Dekodifiká: Ken Bo Ta? Kiko Ta Bo Propósito?"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S2E10/Deel 1 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?.",
      "es": "Documento PDF para Eigen Pad S2E10/Deel 1 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?.",
      "nl": "PDF-document voor Eigen Pad S2E10/Deel 1 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?.",
      "pap": "Dokumento PDF pa Eigen Pad S2E10/Deel 1 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?."
    },
    "url": "./media/Seizoen-2E10-Wie-Ben-Je-Wat-Is-Jou-Doel - Deel 1.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s2e11-deel-2-de-matrix-gedecodeerd-wie-ben-je-wat-is-je-doel-69",
    "title": {
      "en": "Eigen Pad S2E11/Part 2 - The Matrix Decoded: Who Are You? What Is Your Purpose?",
      "es": "Eigen Pad S2E11/Parte 2 - La Matrix Decodificada: ¿Quién Eres? ¿Cuál Es Tu Propósito?",
      "nl": "Eigen Pad S2E11/Deel 2 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?",
      "pap": "Eigen Pad S2E11/Parti 2 - E Matrix Dekodifiká: Ken Bo Ta? Kiko Ta Bo Propósito?"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S2E11/Deel 2 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?.",
      "es": "Documento PDF para Eigen Pad S2E11/Deel 2 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?.",
      "nl": "PDF-document voor Eigen Pad S2E11/Deel 2 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?.",
      "pap": "Dokumento PDF pa Eigen Pad S2E11/Deel 2 - De Matrix Gedecodeerd: Wie Ben Je? Wat is Je Doel?."
    },
    "url": "./media/Seizoen-2E11-Wie-Ben-Je-Wat-Is-Jou-Doel - Deel 2.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-het-occulte-onthuld-terug-naar-de-bron-deel-1-dutch-70",
    "title": {
      "en": "The Occult Revealed: Back To The Source - Part 1 (Dutch)",
      "es": "Lo Oculto Revelado: De Vuelta A La Fuente - Parte 1 (neerlandés)",
      "nl": "Het Occulte Onthuld: Terug Naar De Bron - Deel 1 (Dutch)",
      "pap": "E Okulto Revelá: Bèk Na E Fuente - Parti 1 (hulandes)"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Het Occulte Onthuld: Terug Naar De Bron - Deel 1 (Dutch).",
      "es": "Documento PDF para Het Occulte Onthuld: Terug Naar De Bron - Deel 1 (Dutch).",
      "nl": "PDF-document voor Het Occulte Onthuld: Terug Naar De Bron - Deel 1 (Dutch).",
      "pap": "Dokumento PDF pa Het Occulte Onthuld: Terug Naar De Bron - Deel 1 (Dutch)."
    },
    "url": "/media/het-occulte-onthuld-deel-1.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-het-occulte-onthuld-donker-occultisme-satanisme-deel-2-dutch-71",
    "title": {
      "en": "The Occult Revealed: Dark Occultism (Satanism) - Part 2 (Dutch)",
      "es": "Lo Oculto Revelado: Ocultismo Oscuro (Satanismo) - Parte 2 (neerlandés)",
      "nl": "Het Occulte Onthuld: Donker Occultisme (Satanisme) - Deel 2 (Dutch)",
      "pap": "E Okulto Revelá: Okultismo Skur (Satanismo) - Parti 2 (hulandes)"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Het Occulte Onthuld: Donker Occultisme (Satanisme) - Deel 2 (Dutch).",
      "es": "Documento PDF para Het Occulte Onthuld: Donker Occultisme (Satanisme) - Deel 2 (Dutch).",
      "nl": "PDF-document voor Het Occulte Onthuld: Donker Occultisme (Satanisme) - Deel 2 (Dutch).",
      "pap": "Dokumento PDF pa Het Occulte Onthuld: Donker Occultisme (Satanisme) - Deel 2 (Dutch)."
    },
    "url": "/media/het-occulte-onthuld-deel-2.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-72",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/s3e1-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-73",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Sepher-Ha-Zohar-Excerpts.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-74",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Sepher-HaBahir.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-75",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Sepher-Raziel.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-76",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Sepher-Yetzirah.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-77",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Chicken_Qabalah.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-78",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Kabbalah-For-Beginners.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-79",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Kabbalah-And-Freemasonry.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-80",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Introduction-To-The-Kabbalah.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-81",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Hidden-Treasures-Of-Ancient-Qabalah.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-82",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Hidden-Wisdom-Of-Kabbalah.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-83",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Middle-Pillar.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-84",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Garden-Of-Pomegranates.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-85",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/Blazing-Star.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e1-kabbala-and-tarot-onthuld-symbolen-86",
    "title": {
      "en": "Eigen Pad S3E1: Kabbalah & Tarot Revealed - Symbols",
      "es": "Eigen Pad S3E1: Cábala y Tarot Revelados - Símbolos",
      "nl": "Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen",
      "pap": "Eigen Pad S3E1: Kabala & Tarot Revelá - Símbolonan"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "es": "Documento PDF para Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "nl": "PDF-document voor Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen.",
      "pap": "Dokumento PDF pa Eigen Pad S3E1: Kabbala & Tarot Onthuld - Symbolen."
    },
    "url": "./media/the-book-of-tokens.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e2-kabbala-and-tarot-onthuld-symbolen-en-realiteit-87",
    "title": {
      "en": "Eigen Pad S3E2: Kabbalah & Tarot Revealed - Symbols and Reality",
      "es": "Eigen Pad S3E2: Cábala y Tarot Revelados - Símbolos y Realidad",
      "nl": "Eigen Pad S3E2: Kabbala & Tarot Onthuld - Symbolen en Realiteit",
      "pap": "Eigen Pad S3E2: Kabala & Tarot Revelá - Símbolonan i Realidat"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E2: Kabbala & Tarot Onthuld - Symbolen en Realiteit.",
      "es": "Documento PDF para Eigen Pad S3E2: Kabbala & Tarot Onthuld - Symbolen en Realiteit.",
      "nl": "PDF-document voor Eigen Pad S3E2: Kabbala & Tarot Onthuld - Symbolen en Realiteit.",
      "pap": "Dokumento PDF pa Eigen Pad S3E2: Kabbala & Tarot Onthuld - Symbolen en Realiteit."
    },
    "url": "./media/s3e2-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e3-kabbala-and-tarot-onthuld-contact-maken-met-de-boven-werelden-88",
    "title": {
      "en": "Eigen Pad S3E3: Kabbalah & Tarot Revealed - Making Contact With The Higher Worlds",
      "es": "Eigen Pad S3E3: Cábala y Tarot Revelados - Hacer Contacto Con Los Mundos Superiores",
      "nl": "Eigen Pad S3E3: Kabbala & Tarot Onthuld - Contact Maken Met De Boven Werelden",
      "pap": "Eigen Pad S3E3: Kabala & Tarot Revelá - Hasi Kontakto Ku E Mundunan Superior"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E3: Kabbala & Tarot Onthuld - Contact Maken Met De Boven Werelden.",
      "es": "Documento PDF para Eigen Pad S3E3: Kabbala & Tarot Onthuld - Contact Maken Met De Boven Werelden.",
      "nl": "PDF-document voor Eigen Pad S3E3: Kabbala & Tarot Onthuld - Contact Maken Met De Boven Werelden.",
      "pap": "Dokumento PDF pa Eigen Pad S3E3: Kabbala & Tarot Onthuld - Contact Maken Met De Boven Werelden."
    },
    "url": "./media/s3e3-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e4-kabbala-and-tarot-onthuld-wie-is-god-deel-1-89",
    "title": {
      "en": "Eigen Pad S3E4: Kabbalah & Tarot Revealed - Who Is God? Part 1",
      "es": "Eigen Pad S3E4: Cábala y Tarot Revelados - ¿Quién Es Dios? Parte 1",
      "nl": "Eigen Pad S3E4: Kabbala & Tarot Onthuld - Wie Is God? Deel 1",
      "pap": "Eigen Pad S3E4: Kabala & Tarot Revelá - Ken Ta Dios? Parti 1"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E4: Kabbala & Tarot Onthuld - Wie Is God? Deel 1.",
      "es": "Documento PDF para Eigen Pad S3E4: Kabbala & Tarot Onthuld - Wie Is God? Deel 1.",
      "nl": "PDF-document voor Eigen Pad S3E4: Kabbala & Tarot Onthuld - Wie Is God? Deel 1.",
      "pap": "Dokumento PDF pa Eigen Pad S3E4: Kabbala & Tarot Onthuld - Wie Is God? Deel 1."
    },
    "url": "./media/s3e4-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e5-kabbala-and-tarot-onthuld-wie-is-god-deel-2-90",
    "title": {
      "en": "Eigen Pad S3E5: Kabbalah & Tarot Revealed - Who Is God? Part 2",
      "es": "Eigen Pad S3E5: Cábala y Tarot Revelados - ¿Quién Es Dios? Parte 2",
      "nl": "Eigen Pad S3E5: Kabbala & Tarot Onthuld - Wie Is God? Deel 2",
      "pap": "Eigen Pad S3E5: Kabala & Tarot Revelá - Ken Ta Dios? Parti 2"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E5: Kabbala & Tarot Onthuld - Wie Is God? Deel 2.",
      "es": "Documento PDF para Eigen Pad S3E5: Kabbala & Tarot Onthuld - Wie Is God? Deel 2.",
      "nl": "PDF-document voor Eigen Pad S3E5: Kabbala & Tarot Onthuld - Wie Is God? Deel 2.",
      "pap": "Dokumento PDF pa Eigen Pad S3E5: Kabbala & Tarot Onthuld - Wie Is God? Deel 2."
    },
    "url": "./media/s3e5-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e6-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-deel-1-91",
    "title": {
      "en": "Eigen Pad S3E6: Kabbalah & Tarot Revealed - Through Being, You Will Become, Part 1",
      "es": "Eigen Pad S3E6: Cábala y Tarot Revelados - A Través del Ser, Llegarás a Ser, Parte 1",
      "nl": "Eigen Pad S3E6: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Deel 1",
      "pap": "Eigen Pad S3E6: Kabala & Tarot Revelá - Dor di Ser, Lo Bo Bira, Parti 1"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E6: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Deel 1.",
      "es": "Documento PDF para Eigen Pad S3E6: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Deel 1.",
      "nl": "PDF-document voor Eigen Pad S3E6: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Deel 1.",
      "pap": "Dokumento PDF pa Eigen Pad S3E6: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Deel 1."
    },
    "url": "./media/s3e6-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e7-kabbala-and-tarot-onthuld-door-het-zijn-zal-je-worden-mazzaroth-de-zodiac-deel-2-92",
    "title": {
      "en": "Eigen Pad S3E7: Kabbalah & Tarot Revealed - Through Being, You Will Become, Mazzaroth (The Zodiac) Part 2",
      "es": "Eigen Pad S3E7: Cábala y Tarot Revelados - A Través del Ser, Llegarás a Ser, Mazzaroth (El Zodíaco) Parte 2",
      "nl": "Eigen Pad S3E7: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Mazzaroth (De Zodiac) Deel 2",
      "pap": "Eigen Pad S3E7: Kabala & Tarot Revelá - Dor di Ser, Lo Bo Bira, Mazzaroth (E Zodíako) Parti 2"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E7: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Mazzaroth (De Zodiac) Deel 2.",
      "es": "Documento PDF para Eigen Pad S3E7: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Mazzaroth (De Zodiac) Deel 2.",
      "nl": "PDF-document voor Eigen Pad S3E7: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Mazzaroth (De Zodiac) Deel 2.",
      "pap": "Dokumento PDF pa Eigen Pad S3E7: Kabbala & Tarot Onthuld - Door Het Zijn, Zal Je Worden, Mazzaroth (De Zodiac) Deel 2."
    },
    "url": "./media/s3e7-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e8-mazzaroth-de-zodiac-93",
    "title": {
      "en": "Eigen Pad S3E8: Mazzaroth (The Zodiac)",
      "es": "Eigen Pad S3E8: Mazzaroth (El Zodíaco)",
      "nl": "Eigen Pad S3E8: Mazzaroth (De Zodiac)",
      "pap": "Eigen Pad S3E8: Mazzaroth (E Zodíako)"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E8: Mazzaroth (De Zodiac).",
      "es": "Documento PDF para Eigen Pad S3E8: Mazzaroth (De Zodiac).",
      "nl": "PDF-document voor Eigen Pad S3E8: Mazzaroth (De Zodiac).",
      "pap": "Dokumento PDF pa Eigen Pad S3E8: Mazzaroth (De Zodiac)."
    },
    "url": "./media/s3e8-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e9-gilgulim-reincarnatie-94",
    "title": {
      "en": "Eigen Pad S3E9: Gilgulim (Reincarnation)",
      "es": "Eigen Pad S3E9: Gilgulim (Reencarnación)",
      "nl": "Eigen Pad S3E9: Gilgulim (Reïncarnatie)",
      "pap": "Eigen Pad S3E9: Gilgulim (Reenkarnashon)"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E9: Gilgulim (Reïncarnatie).",
      "es": "Documento PDF para Eigen Pad S3E9: Gilgulim (Reïncarnatie).",
      "nl": "PDF-document voor Eigen Pad S3E9: Gilgulim (Reïncarnatie).",
      "pap": "Dokumento PDF pa Eigen Pad S3E9: Gilgulim (Reïncarnatie)."
    },
    "url": "./media/s3e9-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e10-de-hemelen-en-zijn-wezens-95",
    "title": {
      "en": "Eigen Pad S3E10: The Heavens and Their Beings",
      "es": "Eigen Pad S3E10: Los Cielos y Sus Seres",
      "nl": "Eigen Pad S3E10: De Hemelen en Zijn Wezens",
      "pap": "Eigen Pad S3E10: E Shelunan i Nan Sernan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E10: De Hemelen en Zijn Wezens.",
      "es": "Documento PDF para Eigen Pad S3E10: De Hemelen en Zijn Wezens.",
      "nl": "PDF-document voor Eigen Pad S3E10: De Hemelen en Zijn Wezens.",
      "pap": "Dokumento PDF pa Eigen Pad S3E10: De Hemelen en Zijn Wezens."
    },
    "url": "./media/s3e10-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e11-wat-is-de-shekinah-kundalini-96",
    "title": {
      "en": "Eigen Pad S3E11: What is the Shekinah (Kundalini)?",
      "es": "Eigen Pad S3E11: ¿Qué es la Shekinah (Kundalini)?",
      "nl": "Eigen Pad S3E11: Wat is de Shekinah (Kundalini)?",
      "pap": "Eigen Pad S3E11: Kiko ta e Shekinah (Kundalini)?"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E11: Wat is de Shekinah (Kundalini)?.",
      "es": "Documento PDF para Eigen Pad S3E11: Wat is de Shekinah (Kundalini)?.",
      "nl": "PDF-document voor Eigen Pad S3E11: Wat is de Shekinah (Kundalini)?.",
      "pap": "Dokumento PDF pa Eigen Pad S3E11: Wat is de Shekinah (Kundalini)?."
    },
    "url": "./media/s3e11-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s3e12-het-zelf-en-het-universum-geopenbaard-in-symbolen-tarot-97",
    "title": {
      "en": "Eigen Pad S3E12: The Self and The Universe Revealed in Symbols (Tarot)",
      "es": "Eigen Pad S3E12: El Yo y El Universo Revelados en Símbolos (Tarot)",
      "nl": "Eigen Pad S3E12: Het Zelf en Het Universum Geopenbaard in Symbolen (Tarot)",
      "pap": "Eigen Pad S3E12: E Mes i E Universo Revelá den Símbolonan (Tarot)"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S3E12: Het Zelf en Het Universum Geopenbaard in Symbolen (Tarot).",
      "es": "Documento PDF para Eigen Pad S3E12: Het Zelf en Het Universum Geopenbaard in Symbolen (Tarot).",
      "nl": "PDF-document voor Eigen Pad S3E12: Het Zelf en Het Universum Geopenbaard in Symbolen (Tarot).",
      "pap": "Dokumento PDF pa Eigen Pad S3E12: Het Zelf en Het Universum Geopenbaard in Symbolen (Tarot)."
    },
    "url": "./media/s3e12-de-kabbala-en-tarot-onthuld.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-de-onheilige-drie-eenheid-dutch-98",
    "title": {
      "en": "The Unholy Trinity (Dutch)",
      "es": "La Trinidad Impía (neerlandés)",
      "nl": "De OnHeilige Drie Eenheid (Dutch)",
      "pap": "E Trinidat Insanto (hulandes)"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for De OnHeilige Drie Eenheid (Dutch).",
      "es": "Documento PDF para De OnHeilige Drie Eenheid (Dutch).",
      "nl": "PDF-document voor De OnHeilige Drie Eenheid (Dutch).",
      "pap": "Dokumento PDF pa De OnHeilige Drie Eenheid (Dutch)."
    },
    "url": "/media/de-onheilige-drie-eenheid.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking-99",
    "title": {
      "en": "Eigen Pad S4E1: The Ever-Rising Son/Sun - The Egyptian Revival",
      "es": "Eigen Pad S4E1: El Hijo/Sol Siempre Naciente - El Renacimiento Egipcio",
      "nl": "Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking",
      "pap": "Eigen Pad S4E1: E Yu/Solo Semper Sali - E Renasementu Egipsio"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "es": "Documento PDF para Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "nl": "PDF-document voor Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "pap": "Dokumento PDF pa Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-I-s4e1.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking-100",
    "title": {
      "en": "Eigen Pad S4E1: The Ever-Rising Son/Sun - The Egyptian Revival",
      "es": "Eigen Pad S4E1: El Hijo/Sol Siempre Naciente - El Renacimiento Egipcio",
      "nl": "Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking",
      "pap": "Eigen Pad S4E1: E Yu/Solo Semper Sali - E Renasementu Egipsio"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "es": "Documento PDF para Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "nl": "PDF-document voor Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "pap": "Dokumento PDF pa Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking."
    },
    "url": "./media/s4/Egyptian Revival.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking-101",
    "title": {
      "en": "Eigen Pad S4E1: The Ever-Rising Son/Sun - The Egyptian Revival",
      "es": "Eigen Pad S4E1: El Hijo/Sol Siempre Naciente - El Renacimiento Egipcio",
      "nl": "Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking",
      "pap": "Eigen Pad S4E1: E Yu/Solo Semper Sali - E Renasementu Egipsio"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "es": "Documento PDF para Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "nl": "PDF-document voor Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "pap": "Dokumento PDF pa Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking."
    },
    "url": "./media/s4/Esoteric Origins Of Tarot.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking-102",
    "title": {
      "en": "Eigen Pad S4E1: The Ever-Rising Son/Sun - The Egyptian Revival",
      "es": "Eigen Pad S4E1: El Hijo/Sol Siempre Naciente - El Renacimiento Egipcio",
      "nl": "Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking",
      "pap": "Eigen Pad S4E1: E Yu/Solo Semper Sali - E Renasementu Egipsio"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "es": "Documento PDF para Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "nl": "PDF-document voor Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "pap": "Dokumento PDF pa Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking."
    },
    "url": "./media/s4/Gnostic Tarot.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking-103",
    "title": {
      "en": "Eigen Pad S4E1: The Ever-Rising Son/Sun - The Egyptian Revival",
      "es": "Eigen Pad S4E1: El Hijo/Sol Siempre Naciente - El Renacimiento Egipcio",
      "nl": "Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking",
      "pap": "Eigen Pad S4E1: E Yu/Solo Semper Sali - E Renasementu Egipsio"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "es": "Documento PDF para Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "nl": "PDF-document voor Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "pap": "Dokumento PDF pa Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking."
    },
    "url": "./media/s4/Oracle Of The Tarot - A Course On Tarot Divination.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking-104",
    "title": {
      "en": "Eigen Pad S4E1: The Ever-Rising Son/Sun - The Egyptian Revival",
      "es": "Eigen Pad S4E1: El Hijo/Sol Siempre Naciente - El Renacimiento Egipcio",
      "nl": "Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking",
      "pap": "Eigen Pad S4E1: E Yu/Solo Semper Sali - E Renasementu Egipsio"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "es": "Documento PDF para Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "nl": "PDF-document voor Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "pap": "Dokumento PDF pa Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking."
    },
    "url": "./media/s4/Qabalistic Tarot.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e1-de-steeds-opkomende-zo-o-n-de-egyptische-opwekking-105",
    "title": {
      "en": "Eigen Pad S4E1: The Ever-Rising Son/Sun - The Egyptian Revival",
      "es": "Eigen Pad S4E1: El Hijo/Sol Siempre Naciente - El Renacimiento Egipcio",
      "nl": "Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking",
      "pap": "Eigen Pad S4E1: E Yu/Solo Semper Sali - E Renasementu Egipsio"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "es": "Documento PDF para Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "nl": "PDF-document voor Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking.",
      "pap": "Dokumento PDF pa Eigen Pad S4E1: De Steeds Opkomende Zo(o)n - De Egyptische Opwekking."
    },
    "url": "./media/s4/Symbolist - Guide To Tarot.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e2-de-steeds-opkomende-zo-o-n-de-grote-arcana-106",
    "title": {
      "en": "Eigen Pad S4E2: The Ever-Rising Son/Sun - The Major Arcana",
      "es": "Eigen Pad S4E2: El Hijo/Sol Siempre Naciente - Los Arcanos Mayores",
      "nl": "Eigen Pad S4E2: De Steeds Opkomende Zo(o)n - De Grote Arcana",
      "pap": "Eigen Pad S4E2: E Yu/Solo Semper Sali - E Arkano Mayor"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E2: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "es": "Documento PDF para Eigen Pad S4E2: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "nl": "PDF-document voor Eigen Pad S4E2: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "pap": "Dokumento PDF pa Eigen Pad S4E2: De Steeds Opkomende Zo(o)n - De Grote Arcana."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e2.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e3-de-steeds-opkomende-zo-o-n-de-grote-arcana-107",
    "title": {
      "en": "Eigen Pad S4E3: The Ever-Rising Son/Sun - The Major Arcana",
      "es": "Eigen Pad S4E3: El Hijo/Sol Siempre Naciente - Los Arcanos Mayores",
      "nl": "Eigen Pad S4E3: De Steeds Opkomende Zo(o)n - De Grote Arcana",
      "pap": "Eigen Pad S4E3: E Yu/Solo Semper Sali - E Arkano Mayor"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E3: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "es": "Documento PDF para Eigen Pad S4E3: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "nl": "PDF-document voor Eigen Pad S4E3: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "pap": "Dokumento PDF pa Eigen Pad S4E3: De Steeds Opkomende Zo(o)n - De Grote Arcana."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e3.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e4-de-steeds-opkomende-zo-o-n-de-grote-arcana-108",
    "title": {
      "en": "Eigen Pad S4E4: The Ever-Rising Son/Sun - The Major Arcana",
      "es": "Eigen Pad S4E4: El Hijo/Sol Siempre Naciente - Los Arcanos Mayores",
      "nl": "Eigen Pad S4E4: De Steeds Opkomende Zo(o)n - De Grote Arcana",
      "pap": "Eigen Pad S4E4: E Yu/Solo Semper Sali - E Arkano Mayor"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E4: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "es": "Documento PDF para Eigen Pad S4E4: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "nl": "PDF-document voor Eigen Pad S4E4: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "pap": "Dokumento PDF pa Eigen Pad S4E4: De Steeds Opkomende Zo(o)n - De Grote Arcana."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e4.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e5-de-steeds-opkomende-zo-o-n-de-grote-arcana-109",
    "title": {
      "en": "Eigen Pad S4E5: The Ever-Rising Son/Sun - The Major Arcana",
      "es": "Eigen Pad S4E5: El Hijo/Sol Siempre Naciente - Los Arcanos Mayores",
      "nl": "Eigen Pad S4E5: De Steeds Opkomende Zo(o)n - De Grote Arcana",
      "pap": "Eigen Pad S4E5: E Yu/Solo Semper Sali - E Arkano Mayor"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E5: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "es": "Documento PDF para Eigen Pad S4E5: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "nl": "PDF-document voor Eigen Pad S4E5: De Steeds Opkomende Zo(o)n - De Grote Arcana.",
      "pap": "Dokumento PDF pa Eigen Pad S4E5: De Steeds Opkomende Zo(o)n - De Grote Arcana."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-II-s4e5.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e6-de-steeds-opkomende-zo-o-n-de-kleine-arcana-staven-110",
    "title": {
      "en": "Eigen Pad S4E6: The Ever-Rising Son/Sun - The Minor Arcana/Wands",
      "es": "Eigen Pad S4E6: El Hijo/Sol Siempre Naciente - Los Arcanos Menores/Bastos",
      "nl": "Eigen Pad S4E6: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Staven",
      "pap": "Eigen Pad S4E6: E Yu/Solo Semper Sali - E Arkano Menor/Garoti"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E6: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Staven.",
      "es": "Documento PDF para Eigen Pad S4E6: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Staven.",
      "nl": "PDF-document voor Eigen Pad S4E6: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Staven.",
      "pap": "Dokumento PDF pa Eigen Pad S4E6: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Staven."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e6.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e7-de-steeds-opkomende-zo-o-n-de-kleine-arcana-bekers-111",
    "title": {
      "en": "Eigen Pad S4E7: The Ever-Rising Son/Sun - The Minor Arcana/Cups",
      "es": "Eigen Pad S4E7: El Hijo/Sol Siempre Naciente - Los Arcanos Menores/Copas",
      "nl": "Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers",
      "pap": "Eigen Pad S4E7: E Yu/Solo Semper Sali - E Arkano Menor/Kopa"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers.",
      "es": "Documento PDF para Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers.",
      "nl": "PDF-document voor Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers.",
      "pap": "Dokumento PDF pa Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e7.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e7-de-steeds-opkomende-zo-o-n-de-kleine-arcana-bekers-112",
    "title": {
      "en": "Eigen Pad S4E7: The Ever-Rising Son/Sun - The Minor Arcana/Cups",
      "es": "Eigen Pad S4E7: El Hijo/Sol Siempre Naciente - Los Arcanos Menores/Copas",
      "nl": "Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers",
      "pap": "Eigen Pad S4E7: E Yu/Solo Semper Sali - E Arkano Menor/Kopa"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers.",
      "es": "Documento PDF para Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers.",
      "nl": "PDF-document voor Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers.",
      "pap": "Dokumento PDF pa Eigen Pad S4E7: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Bekers."
    },
    "url": "./media/s4/lijst-van-emoties.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e8-de-steeds-opkomende-zo-o-n-de-kleine-arcana-zwaarden-113",
    "title": {
      "en": "Eigen Pad S4E8: The Ever-Rising Son/Sun - The Minor Arcana/Swords",
      "es": "Eigen Pad S4E8: El Hijo/Sol Siempre Naciente - Los Arcanos Menores/Espadas",
      "nl": "Eigen Pad S4E8: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Zwaarden",
      "pap": "Eigen Pad S4E8: E Yu/Solo Semper Sali - E Arkano Menor/Spada"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E8: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Zwaarden.",
      "es": "Documento PDF para Eigen Pad S4E8: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Zwaarden.",
      "nl": "PDF-document voor Eigen Pad S4E8: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Zwaarden.",
      "pap": "Dokumento PDF pa Eigen Pad S4E8: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Zwaarden."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e8.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e9-de-steeds-opkomende-zo-o-n-de-kleine-arcana-pentakels-114",
    "title": {
      "en": "Eigen Pad S4E9: The Ever-Rising Son/Sun - The Minor Arcana/Pentacles",
      "es": "Eigen Pad S4E9: El Hijo/Sol Siempre Naciente - Los Arcanos Menores/Oros",
      "nl": "Eigen Pad S4E9: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Pentakels",
      "pap": "Eigen Pad S4E9: E Yu/Solo Semper Sali - E Arkano Menor/Pentákulo"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E9: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Pentakels.",
      "es": "Documento PDF para Eigen Pad S4E9: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Pentakels.",
      "nl": "PDF-document voor Eigen Pad S4E9: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Pentakels.",
      "pap": "Dokumento PDF pa Eigen Pad S4E9: De Steeds Opkomende Zo(o)n - De Kleine Arcana/Pentakels."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e9.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e10-de-steeds-opkomende-zo-o-n-integratie-van-de-grote-en-kleine-arcana-115",
    "title": {
      "en": "Eigen Pad S4E10: The Ever-Rising Son/Sun - Integration of the Major and Minor Arcana",
      "es": "Eigen Pad S4E10: El Hijo/Sol Siempre Naciente - Integración de los Arcanos Mayores y Menores",
      "nl": "Eigen Pad S4E10: De Steeds Opkomende Zo(o)n - Integratie van de Grote en Kleine Arcana",
      "pap": "Eigen Pad S4E10: E Yu/Solo Semper Sali - Integrashon di e Arkano Mayor i Menor"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E10: De Steeds Opkomende Zo(o)n - Integratie van de Grote en Kleine Arcana.",
      "es": "Documento PDF para Eigen Pad S4E10: De Steeds Opkomende Zo(o)n - Integratie van de Grote en Kleine Arcana.",
      "nl": "PDF-document voor Eigen Pad S4E10: De Steeds Opkomende Zo(o)n - Integratie van de Grote en Kleine Arcana.",
      "pap": "Dokumento PDF pa Eigen Pad S4E10: De Steeds Opkomende Zo(o)n - Integratie van de Grote en Kleine Arcana."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e10.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e11-de-steeds-opkomende-zo-o-n-hebreeuwse-letters-getallen-en-de-kabbalistische-leve-116",
    "title": {
      "en": "Eigen Pad S4E11: The Ever-Rising Son/Sun - Hebrew Letters, Numbers and the Kabbalistic Tree of Life",
      "es": "Eigen Pad S4E11: El Hijo/Sol Siempre Naciente - Letras Hebreas, Números y el Árbol de la Vida Cabalístico",
      "nl": "Eigen Pad S4E11: De Steeds Opkomende Zo(o)n - Hebreeuwse letters, getallen en de Kabbalistische Levensboom",
      "pap": "Eigen Pad S4E11: E Yu/Solo Semper Sali - Lèternan Hebreo, Number i e Palu di Bida Kabalístiko"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E11: De Steeds Opkomende Zo(o)n - Hebreeuwse letters, getallen en de Kabbalistische Levensboom.",
      "es": "Documento PDF para Eigen Pad S4E11: De Steeds Opkomende Zo(o)n - Hebreeuwse letters, getallen en de Kabbalistische Levensboom.",
      "nl": "PDF-document voor Eigen Pad S4E11: De Steeds Opkomende Zo(o)n - Hebreeuwse letters, getallen en de Kabbalistische Levensboom.",
      "pap": "Dokumento PDF pa Eigen Pad S4E11: De Steeds Opkomende Zo(o)n - Hebreeuwse letters, getallen en de Kabbalistische Levensboom."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e11.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e12-de-steeds-opkomende-zo-o-n-alchemistische-symboliek-in-tarot-zelftransformatie-117",
    "title": {
      "en": "Eigen Pad S4E12: The Ever-Rising Son/Sun - Alchemical Symbolism in Tarot – Self-Transformation",
      "es": "Eigen Pad S4E12: El Hijo/Sol Siempre Naciente - Simbolismo Alquímico en el Tarot – Autotransformación",
      "nl": "Eigen Pad S4E12: De Steeds Opkomende Zo(o)n - Alchemistische symboliek in Tarot – Zelftransformatie",
      "pap": "Eigen Pad S4E12: E Yu/Solo Semper Sali - Simbolismo Alkímiko den Tarot – Outotransformashon"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E12: De Steeds Opkomende Zo(o)n - Alchemistische symboliek in Tarot – Zelftransformatie.",
      "es": "Documento PDF para Eigen Pad S4E12: De Steeds Opkomende Zo(o)n - Alchemistische symboliek in Tarot – Zelftransformatie.",
      "nl": "PDF-document voor Eigen Pad S4E12: De Steeds Opkomende Zo(o)n - Alchemistische symboliek in Tarot – Zelftransformatie.",
      "pap": "Dokumento PDF pa Eigen Pad S4E12: De Steeds Opkomende Zo(o)n - Alchemistische symboliek in Tarot – Zelftransformatie."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e12.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s4e13-de-steeds-opkomende-zo-o-n-waarzeggerij-kaartenleggingen-en-praktische-toepassin-118",
    "title": {
      "en": "Eigen Pad S4E13: The Ever-Rising Son/Sun - Divination, Card Spreads and Practical Application",
      "es": "Eigen Pad S4E13: El Hijo/Sol Siempre Naciente - Adivinación, Tiradas de Cartas y Aplicación Práctica",
      "nl": "Eigen Pad S4E13: De Steeds Opkomende Zo(o)n - Waarzeggerij, Kaartenleggingen en Praktische Toepassing",
      "pap": "Eigen Pad S4E13: E Yu/Solo Semper Sali - Divinashon, Plasamentu di Karta i Aplikashon Práktiko"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S4E13: De Steeds Opkomende Zo(o)n - Waarzeggerij, Kaartenleggingen en Praktische Toepassing.",
      "es": "Documento PDF para Eigen Pad S4E13: De Steeds Opkomende Zo(o)n - Waarzeggerij, Kaartenleggingen en Praktische Toepassing.",
      "nl": "PDF-document voor Eigen Pad S4E13: De Steeds Opkomende Zo(o)n - Waarzeggerij, Kaartenleggingen en Praktische Toepassing.",
      "pap": "Dokumento PDF pa Eigen Pad S4E13: De Steeds Opkomende Zo(o)n - Waarzeggerij, Kaartenleggingen en Praktische Toepassing."
    },
    "url": "./media/s4/de-steeds-opkomende-zon-deel-III-s4e13.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-119",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e1.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-120",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/codex-vaticanus.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-121",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/geneva_bible1560.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-122",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/king-james-version.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-123",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/massoretic-text.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-124",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/septuaginta.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-125",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/statenvertaling.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-126",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/tanakh.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-127",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/textus-receptus.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-128",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/vulgate.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-129",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/codex-sinaiticus.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-130",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/aleppo.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-131",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/alexandrinus.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-132",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/bazae.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-133",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/leningrad.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-134",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/samaritan-torah.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-135",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/peshitta-syriac-new-testament.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-136",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/peshitta-syriac-old-testament.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-137",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/tanakh-with-targum.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-138",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/the-bible-unearthed.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-139",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/david-and-solomon.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-140",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/72-names-of-god-shemhamephorash-nl.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-141",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/72-names-of-god-shemhamephorash.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-142",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/the-descent-of-ishtar.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-143",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/enuma-elish-and-atrahasis-timothy-stephany-version.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-144",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/volledige-lijst-van-babylonische-kronieken.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-145",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/descent-of-inanna.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-146",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/tammuz-and-ishtar.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-147",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/ziggurat-of-enki-descent-of-ishtar.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-148",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/code-of-hammubari.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-149",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/the-myth-of-etana.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-150",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/epic-of-atrahasis.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-151",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/epic-of-gilgamesh.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-152",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/enuma-elish.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-153",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/the-dead-sea-scrolls-english.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-154",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/the-nag-hammadi.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-155",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/mesopotamian-chronicles.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-156",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/assyrian-and-babylonian-chronicles.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-157",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/manetho-aegyptiaca.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-158",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/flavius-josephus-contra-apionem-EN.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e1-de-occulte-kant-van-de-bijbel-introductie-tijdlijn-en-interpretaties-159",
    "title": {
      "en": "Eigen Pad S5E1: The Occult Side of the Bible - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S5E1: El Lado Oculto de la Biblia - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S5E1: E Banda Okulto di Beibel - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S5E1: De Occulte Kant van de Bijbel - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s5/flavius-josephus-contra-apionem-GR.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e2-de-occulte-kant-van-de-bijbel-genesis-van-de-schriften-160",
    "title": {
      "en": "Eigen Pad S5E2: The Occult Side of the Bible - Genesis of the Scriptures",
      "es": "Eigen Pad S5E2: El Lado Oculto de la Biblia - Génesis de las Escrituras",
      "nl": "Eigen Pad S5E2: De Occulte Kant van de Bijbel - Genesis van de Schriften",
      "pap": "Eigen Pad S5E2: E Banda Okulto di Beibel - Génesis di e Skrituranan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E2: De Occulte Kant van de Bijbel - Genesis van de Schriften.",
      "es": "Documento PDF para Eigen Pad S5E2: De Occulte Kant van de Bijbel - Genesis van de Schriften.",
      "nl": "PDF-document voor Eigen Pad S5E2: De Occulte Kant van de Bijbel - Genesis van de Schriften.",
      "pap": "Dokumento PDF pa Eigen Pad S5E2: De Occulte Kant van de Bijbel - Genesis van de Schriften."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e2.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e3-de-occulte-kant-van-de-bijbel-genesis-t-m-jozua-161",
    "title": {
      "en": "Eigen Pad S5E3: The Occult Side of the Bible - Genesis through Joshua",
      "es": "Eigen Pad S5E3: El Lado Oculto de la Biblia - Génesis hasta Josué",
      "nl": "Eigen Pad S5E3: De Occulte Kant van de Bijbel - Genesis t/m Jozua",
      "pap": "Eigen Pad S5E3: E Banda Okulto di Beibel - Génesis te Josué"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E3: De Occulte Kant van de Bijbel - Genesis t/m Jozua.",
      "es": "Documento PDF para Eigen Pad S5E3: De Occulte Kant van de Bijbel - Genesis t/m Jozua.",
      "nl": "PDF-document voor Eigen Pad S5E3: De Occulte Kant van de Bijbel - Genesis t/m Jozua.",
      "pap": "Dokumento PDF pa Eigen Pad S5E3: De Occulte Kant van de Bijbel - Genesis t/m Jozua."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e3.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e4-de-occulte-kant-van-de-bijbel-jozua-t-m-2-samuel-162",
    "title": {
      "en": "Eigen Pad S5E4: The Occult Side of the Bible - Joshua through 2 Samuel",
      "es": "Eigen Pad S5E4: El Lado Oculto de la Biblia - Josué hasta 2 Samuel",
      "nl": "Eigen Pad S5E4: De Occulte Kant van de Bijbel - Jozua t/m 2 Samuel",
      "pap": "Eigen Pad S5E4: E Banda Okulto di Beibel - Josué te 2 Samuel"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E4: De Occulte Kant van de Bijbel - Jozua t/m 2 Samuel.",
      "es": "Documento PDF para Eigen Pad S5E4: De Occulte Kant van de Bijbel - Jozua t/m 2 Samuel.",
      "nl": "PDF-document voor Eigen Pad S5E4: De Occulte Kant van de Bijbel - Jozua t/m 2 Samuel.",
      "pap": "Dokumento PDF pa Eigen Pad S5E4: De Occulte Kant van de Bijbel - Jozua t/m 2 Samuel."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e4.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e5-de-occulte-kant-van-de-bijbel-1-samuel-t-m-2-kronieken-163",
    "title": {
      "en": "Eigen Pad S5E5: The Occult Side of the Bible - 1 Samuel through 2 Chronicles",
      "es": "Eigen Pad S5E5: El Lado Oculto de la Biblia - 1 Samuel hasta 2 Crónicas",
      "nl": "Eigen Pad S5E5: De Occulte Kant van de Bijbel - 1 Samuel t/m 2 Kronieken",
      "pap": "Eigen Pad S5E5: E Banda Okulto di Beibel - 1 Samuel te 2 Krónika"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E5: De Occulte Kant van de Bijbel - 1 Samuel t/m 2 Kronieken.",
      "es": "Documento PDF para Eigen Pad S5E5: De Occulte Kant van de Bijbel - 1 Samuel t/m 2 Kronieken.",
      "nl": "PDF-document voor Eigen Pad S5E5: De Occulte Kant van de Bijbel - 1 Samuel t/m 2 Kronieken.",
      "pap": "Dokumento PDF pa Eigen Pad S5E5: De Occulte Kant van de Bijbel - 1 Samuel t/m 2 Kronieken."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e5.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e6-de-occulte-kant-van-de-bijbel-jesaja-jeremia-ezechiel-daniel-hosea-t-m-maleachi-164",
    "title": {
      "en": "Eigen Pad S5E6: The Occult Side of the Bible - Isaiah, Jeremiah, Ezekiel, Daniel, Hosea through Malachi",
      "es": "Eigen Pad S5E6: El Lado Oculto de la Biblia - Isaías, Jeremías, Ezequiel, Daniel, Oseas hasta Malaquías",
      "nl": "Eigen Pad S5E6: De Occulte Kant van de Bijbel - Jesaja, Jeremia, Ezechiël, Daniel, Hosea t/m Maleachi",
      "pap": "Eigen Pad S5E6: E Banda Okulto di Beibel - Isaías, Jeremías, Ezekiel, Daniel, Oseas te Malakias"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E6: De Occulte Kant van de Bijbel - Jesaja, Jeremia, Ezechiël, Daniel, Hosea t/m Maleachi.",
      "es": "Documento PDF para Eigen Pad S5E6: De Occulte Kant van de Bijbel - Jesaja, Jeremia, Ezechiël, Daniel, Hosea t/m Maleachi.",
      "nl": "PDF-document voor Eigen Pad S5E6: De Occulte Kant van de Bijbel - Jesaja, Jeremia, Ezechiël, Daniel, Hosea t/m Maleachi.",
      "pap": "Dokumento PDF pa Eigen Pad S5E6: De Occulte Kant van de Bijbel - Jesaja, Jeremia, Ezechiël, Daniel, Hosea t/m Maleachi."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e6.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e7-de-occulte-kant-van-de-bijbel-ezra-nehemia-esther-judith-tobit-165",
    "title": {
      "en": "Eigen Pad S5E7: The Occult Side of the Bible - Ezra, Nehemiah, Esther, (Judith, Tobit)",
      "es": "Eigen Pad S5E7: El Lado Oculto de la Biblia - Esdras, Nehemías, Ester, (Judit, Tobías)",
      "nl": "Eigen Pad S5E7: De Occulte Kant van de Bijbel - Ezra, Nehemia, Esther, (Judith, Tobit)",
      "pap": "Eigen Pad S5E7: E Banda Okulto di Beibel - Esra, Nehemías, Ester, (Judit, Tobit)"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E7: De Occulte Kant van de Bijbel - Ezra, Nehemia, Esther, (Judith, Tobit).",
      "es": "Documento PDF para Eigen Pad S5E7: De Occulte Kant van de Bijbel - Ezra, Nehemia, Esther, (Judith, Tobit).",
      "nl": "PDF-document voor Eigen Pad S5E7: De Occulte Kant van de Bijbel - Ezra, Nehemia, Esther, (Judith, Tobit).",
      "pap": "Dokumento PDF pa Eigen Pad S5E7: De Occulte Kant van de Bijbel - Ezra, Nehemia, Esther, (Judith, Tobit)."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e7.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e8-de-occulte-kant-van-de-bijbel-1-and-2-makkabeeen-166",
    "title": {
      "en": "Eigen Pad S5E8: The Occult Side of the Bible - 1 & 2 Maccabees",
      "es": "Eigen Pad S5E8: El Lado Oculto de la Biblia - 1 y 2 Macabeos",
      "nl": "Eigen Pad S5E8: De Occulte Kant van de Bijbel - 1 & 2 Makkabeeën",
      "pap": "Eigen Pad S5E8: E Banda Okulto di Beibel - 1 i 2 Makabeo"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E8: De Occulte Kant van de Bijbel - 1 & 2 Makkabeeën.",
      "es": "Documento PDF para Eigen Pad S5E8: De Occulte Kant van de Bijbel - 1 & 2 Makkabeeën.",
      "nl": "PDF-document voor Eigen Pad S5E8: De Occulte Kant van de Bijbel - 1 & 2 Makkabeeën.",
      "pap": "Dokumento PDF pa Eigen Pad S5E8: De Occulte Kant van de Bijbel - 1 & 2 Makkabeeën."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e8.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e9-de-occulte-kant-van-de-bijbel-job-psalmen-spreuken-prediker-hooglied-klaagliedere-167",
    "title": {
      "en": "Eigen Pad S5E9: The Occult Side of the Bible - Job, Psalms, Proverbs, Ecclesiastes, Song of Songs, Lamentations, Ecclesiasticus, Wisdom of Solomon, Baruch",
      "es": "Eigen Pad S5E9: El Lado Oculto de la Biblia - Job, Salmos, Proverbios, Eclesiastés, Cantar de los Cantares, Lamentaciones, Eclesiástico, Sabiduría de Salomón, Baruc",
      "nl": "Eigen Pad S5E9: De Occulte Kant van de Bijbel - Job, Psalmen, Spreuken, Prediker, Hooglied, Klaagliederen, Ecclesiasticus, Wijsheid van Salomo, Baruch",
      "pap": "Eigen Pad S5E9: E Banda Okulto di Beibel - Job, Salmonan, Proverbionan, Eklesiastés, Kantika di Kantikanan, Lamentashonnan, Eklesiástiko, Sabiduria di Salomon, Baruk"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E9: De Occulte Kant van de Bijbel - Job, Psalmen, Spreuken, Prediker, Hooglied, Klaagliederen, Ecclesiasticus, Wijsheid van Salomo, Baruch.",
      "es": "Documento PDF para Eigen Pad S5E9: De Occulte Kant van de Bijbel - Job, Psalmen, Spreuken, Prediker, Hooglied, Klaagliederen, Ecclesiasticus, Wijsheid van Salomo, Baruch.",
      "nl": "PDF-document voor Eigen Pad S5E9: De Occulte Kant van de Bijbel - Job, Psalmen, Spreuken, Prediker, Hooglied, Klaagliederen, Ecclesiasticus, Wijsheid van Salomo, Baruch.",
      "pap": "Dokumento PDF pa Eigen Pad S5E9: De Occulte Kant van de Bijbel - Job, Psalmen, Spreuken, Prediker, Hooglied, Klaagliederen, Ecclesiasticus, Wijsheid van Salomo, Baruch."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e9.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e10-de-occulte-kant-van-de-bijbel-matteus-marcus-lucas-johannes-en-handelingen-168",
    "title": {
      "en": "Eigen Pad S5E10: The Occult Side of the Bible - Matthew, Mark, Luke, John and Acts",
      "es": "Eigen Pad S5E10: El Lado Oculto de la Biblia - Mateo, Marcos, Lucas, Juan y Hechos",
      "nl": "Eigen Pad S5E10: De Occulte Kant van de Bijbel - Matteüs, Marcus, Lucas, Johannes en Handelingen",
      "pap": "Eigen Pad S5E10: E Banda Okulto di Beibel - Mateo, Marko, Lukas, Huan i Echonan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E10: De Occulte Kant van de Bijbel - Matteüs, Marcus, Lucas, Johannes en Handelingen.",
      "es": "Documento PDF para Eigen Pad S5E10: De Occulte Kant van de Bijbel - Matteüs, Marcus, Lucas, Johannes en Handelingen.",
      "nl": "PDF-document voor Eigen Pad S5E10: De Occulte Kant van de Bijbel - Matteüs, Marcus, Lucas, Johannes en Handelingen.",
      "pap": "Dokumento PDF pa Eigen Pad S5E10: De Occulte Kant van de Bijbel - Matteüs, Marcus, Lucas, Johannes en Handelingen."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e10.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e11-de-occulte-kant-van-de-bijbel-romeinen-korintiers-galaten-efeziers-filippenzen-k-169",
    "title": {
      "en": "Eigen Pad S5E11: The Occult Side of the Bible - Romans, Corinthians, Galatians, Ephesians, Philippians, Colossians, Thessalonians, Timothy, Titus, Philemon, Hebrews, James, Peter, John, Jude",
      "es": "Eigen Pad S5E11: El Lado Oculto de la Biblia - Romanos, Corintios, Gálatas, Efesios, Filipenses, Colosenses, Tesalonicenses, Timoteo, Tito, Filemón, Hebreos, Santiago, Pedro, Juan, Judas",
      "nl": "Eigen Pad S5E11: De Occulte Kant van de Bijbel - Romeinen, Korintiërs, Galaten, Efeziërs, Filippenzen, Kolossenzen, Thessalonicenzen, Timotheüs, Titus, Filemon, Hebreeën, Jakobus, Petrus, Johannes, Judas",
      "pap": "Eigen Pad S5E11: E Banda Okulto di Beibel - Romanonan, Korintionan, Galatianan, Efesionan, Filipensenan, Kolosensenan, Tesalonisensenan, Timoteo, Tito, Filemon, Hebreonan, Santiago, Pedro, Huan, Hudas"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E11: De Occulte Kant van de Bijbel - Romeinen, Korintiërs, Galaten, Efeziërs, Filippenzen, Kolossenzen, Thessalonicenzen, Timotheüs, Titus, Filemon, Hebreeën, Jakobus, Petrus, Johannes, Judas.",
      "es": "Documento PDF para Eigen Pad S5E11: De Occulte Kant van de Bijbel - Romeinen, Korintiërs, Galaten, Efeziërs, Filippenzen, Kolossenzen, Thessalonicenzen, Timotheüs, Titus, Filemon, Hebreeën, Jakobus, Petrus, Johannes, Judas.",
      "nl": "PDF-document voor Eigen Pad S5E11: De Occulte Kant van de Bijbel - Romeinen, Korintiërs, Galaten, Efeziërs, Filippenzen, Kolossenzen, Thessalonicenzen, Timotheüs, Titus, Filemon, Hebreeën, Jakobus, Petrus, Johannes, Judas.",
      "pap": "Dokumento PDF pa Eigen Pad S5E11: De Occulte Kant van de Bijbel - Romeinen, Korintiërs, Galaten, Efeziërs, Filippenzen, Kolossenzen, Thessalonicenzen, Timotheüs, Titus, Filemon, Hebreeën, Jakobus, Petrus, Johannes, Judas."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e11.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s5e12-de-occulte-kant-van-de-bijbel-openbaring-170",
    "title": {
      "en": "Eigen Pad S5E12: The Occult Side of the Bible - Revelation",
      "es": "Eigen Pad S5E12: El Lado Oculto de la Biblia - Apocalipsis",
      "nl": "Eigen Pad S5E12: De Occulte Kant van de Bijbel - Openbaring",
      "pap": "Eigen Pad S5E12: E Banda Okulto di Beibel - Revelashon"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S5E12: De Occulte Kant van de Bijbel - Openbaring.",
      "es": "Documento PDF para Eigen Pad S5E12: De Occulte Kant van de Bijbel - Openbaring.",
      "nl": "PDF-document voor Eigen Pad S5E12: De Occulte Kant van de Bijbel - Openbaring.",
      "pap": "Dokumento PDF pa Eigen Pad S5E12: De Occulte Kant van de Bijbel - Openbaring."
    },
    "url": "./media/s5/dark-side-of-the-bible-s5e12.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-de-gereformeerde-cultus-van-de-staat-waar-gehoorzaamheid-de-godin-wurgt-en-ordevolgers-slavernij-171",
    "title": {
      "en": "The Reformed Cult Of The State | Where obedience strangles the goddess, and order-followers keep slavery in place.",
      "es": "El Culto Reformado Del Estado | Donde la obediencia estrangula a la diosa, y los seguidores de órdenes mantienen la esclavitud.",
      "nl": "De Gereformeerde Cultus Van De Staat | Waar gehoorzaamheid de godin wurgt, en ordevolgers slavernij in stand houden.",
      "pap": "E Kulto Reformá Di E Estado | Kaminda obedensia ta wuru e diosa, i siguidónan di órdu ta mantené esklabitut."
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for De Gereformeerde Cultus Van De Staat | Waar gehoorzaamheid de godin wurgt, en ordevolgers slavernij in stand houden..",
      "es": "Documento PDF para De Gereformeerde Cultus Van De Staat | Waar gehoorzaamheid de godin wurgt, en ordevolgers slavernij in stand houden..",
      "nl": "PDF-document voor De Gereformeerde Cultus Van De Staat | Waar gehoorzaamheid de godin wurgt, en ordevolgers slavernij in stand houden..",
      "pap": "Dokumento PDF pa De Gereformeerde Cultus Van De Staat | Waar gehoorzaamheid de godin wurgt, en ordevolgers slavernij in stand houden.."
    },
    "url": "/media/de-gereformeerde-cultus-van-de-staat.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties-172",
    "title": {
      "en": "Eigen Pad S6E1: The Epic of Gilgamesh - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S6E1: La Epopeya de Gilgamesh - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S6E1: E Epopeya di Gilgamesh - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s6/het-gilgamesj-epos-s6e1.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties-173",
    "title": {
      "en": "Eigen Pad S6E1: The Epic of Gilgamesh - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S6E1: La Epopeya de Gilgamesh - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S6E1: E Epopeya di Gilgamesh - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s6/gilgamesh-en.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s6e1-het-gilgamesj-epos-introductie-tijdlijn-en-interpretaties-174",
    "title": {
      "en": "Eigen Pad S6E1: The Epic of Gilgamesh - Introduction, Timeline and Interpretations",
      "es": "Eigen Pad S6E1: La Epopeya de Gilgamesh - Introducción, Cronología e Interpretaciones",
      "nl": "Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties",
      "pap": "Eigen Pad S6E1: E Epopeya di Gilgamesh - Introdukshon, Linea di Tempu i Interpretashonnan"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties.",
      "es": "Documento PDF para Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties.",
      "nl": "PDF-document voor Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties.",
      "pap": "Dokumento PDF pa Eigen Pad S6E1: Het Gilgamesj-Epos - Introductie, Tijdlijn en Interpretaties."
    },
    "url": "./media/s6/gilgamesh-nl.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s6e2-het-gilgamesj-epos-tablet-i-het-ego-175",
    "title": {
      "en": "Eigen Pad S6E2: The Epic of Gilgamesh | Tablet I - The Ego",
      "es": "Eigen Pad S6E2: La Epopeya de Gilgamesh | Tablilla I - El Ego",
      "nl": "Eigen Pad S6E2: Het Gilgamesj-Epos | Tablet I - Het Ego",
      "pap": "Eigen Pad S6E2: E Epopeya di Gilgamesh | Tablèt I - E Ego"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S6E2: Het Gilgamesj-Epos | Tablet I - Het Ego.",
      "es": "Documento PDF para Eigen Pad S6E2: Het Gilgamesj-Epos | Tablet I - Het Ego.",
      "nl": "PDF-document voor Eigen Pad S6E2: Het Gilgamesj-Epos | Tablet I - Het Ego.",
      "pap": "Dokumento PDF pa Eigen Pad S6E2: Het Gilgamesj-Epos | Tablet I - Het Ego."
    },
    "url": "./media/s6/het-gilgamesj-epos-s6e2.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s6e3-het-gilgamesj-epos-tablet-ii-de-schaduw-176",
    "title": {
      "en": "Eigen Pad S6E3: The Epic of Gilgamesh | Tablet II - The Shadow",
      "es": "Eigen Pad S6E3: La Epopeya de Gilgamesh | Tablilla II - La Sombra",
      "nl": "Eigen Pad S6E3: Het Gilgamesj-Epos | Tablet II - De Schaduw",
      "pap": "Eigen Pad S6E3: E Epopeya di Gilgamesh | Tablèt II - E Sombra"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S6E3: Het Gilgamesj-Epos | Tablet II - De Schaduw.",
      "es": "Documento PDF para Eigen Pad S6E3: Het Gilgamesj-Epos | Tablet II - De Schaduw.",
      "nl": "PDF-document voor Eigen Pad S6E3: Het Gilgamesj-Epos | Tablet II - De Schaduw.",
      "pap": "Dokumento PDF pa Eigen Pad S6E3: Het Gilgamesj-Epos | Tablet II - De Schaduw."
    },
    "url": "./media/s6/het-gilgamesj-epos-s6e3.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s6e4-het-gilgamesj-epos-tablet-iii-t-m-iv-de-reis-177",
    "title": {
      "en": "Eigen Pad S6E4: The Epic of Gilgamesh | Tablets III–IV - The Journey",
      "es": "Eigen Pad S6E4: La Epopeya de Gilgamesh | Tablillas III–IV - El Viaje",
      "nl": "Eigen Pad S6E4: Het Gilgamesj-Epos | Tablet III t/m IV - De Reis",
      "pap": "Eigen Pad S6E4: E Epopeya di Gilgamesh | Tablèt III–IV - E Biahe"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S6E4: Het Gilgamesj-Epos | Tablet III t/m IV - De Reis.",
      "es": "Documento PDF para Eigen Pad S6E4: Het Gilgamesj-Epos | Tablet III t/m IV - De Reis.",
      "nl": "PDF-document voor Eigen Pad S6E4: Het Gilgamesj-Epos | Tablet III t/m IV - De Reis.",
      "pap": "Dokumento PDF pa Eigen Pad S6E4: Het Gilgamesj-Epos | Tablet III t/m IV - De Reis."
    },
    "url": "./media/s6/het-gilgamesj-epos-s6e4.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s6e5-het-gilgamesj-epos-tablet-v-de-confrontatie-178",
    "title": {
      "en": "Eigen Pad S6E5: The Epic of Gilgamesh | Tablet V - The Confrontation",
      "es": "Eigen Pad S6E5: La Epopeya de Gilgamesh | Tablilla V - La Confrontación",
      "nl": "Eigen Pad S6E5: Het Gilgamesj-Epos | Tablet V - De Confrontatie",
      "pap": "Eigen Pad S6E5: E Epopeya di Gilgamesh | Tablèt V - E Konfrontashon"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S6E5: Het Gilgamesj-Epos | Tablet V - De Confrontatie.",
      "es": "Documento PDF para Eigen Pad S6E5: Het Gilgamesj-Epos | Tablet V - De Confrontatie.",
      "nl": "PDF-document voor Eigen Pad S6E5: Het Gilgamesj-Epos | Tablet V - De Confrontatie.",
      "pap": "Dokumento PDF pa Eigen Pad S6E5: Het Gilgamesj-Epos | Tablet V - De Confrontatie."
    },
    "url": "./media/s6/het-gilgamesj-epos-s6e5.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s6e6-het-gilgamesj-epos-tablet-vi-verlangen-en-beheersing-179",
    "title": {
      "en": "Eigen Pad S6E6: The Epic of Gilgamesh | Tablet VI - Desire and Mastery",
      "es": "Eigen Pad S6E6: La Epopeya de Gilgamesh | Tablilla VI - Deseo y Dominio",
      "nl": "Eigen Pad S6E6: Het Gilgamesj-Epos | Tablet VI - Verlangen en Beheersing",
      "pap": "Eigen Pad S6E6: E Epopeya di Gilgamesh | Tablèt VI - Deseo i Dominio"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S6E6: Het Gilgamesj-Epos | Tablet VI - Verlangen en Beheersing.",
      "es": "Documento PDF para Eigen Pad S6E6: Het Gilgamesj-Epos | Tablet VI - Verlangen en Beheersing.",
      "nl": "PDF-document voor Eigen Pad S6E6: Het Gilgamesj-Epos | Tablet VI - Verlangen en Beheersing.",
      "pap": "Dokumento PDF pa Eigen Pad S6E6: Het Gilgamesj-Epos | Tablet VI - Verlangen en Beheersing."
    },
    "url": "./media/s6/het-gilgamesj-epos-s6e6.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s6e7-het-gilgamesj-epos-tablet-vii-de-dood-180",
    "title": {
      "en": "Eigen Pad S6E7: The Epic of Gilgamesh | Tablet VII - Death",
      "es": "Eigen Pad S6E7: La Epopeya de Gilgamesh | Tablilla VII - La Muerte",
      "nl": "Eigen Pad S6E7: Het Gilgamesj-Epos | Tablet VII - De Dood",
      "pap": "Eigen Pad S6E7: E Epopeya di Gilgamesh | Tablèt VII - Morto"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S6E7: Het Gilgamesj-Epos | Tablet VII - De Dood.",
      "es": "Documento PDF para Eigen Pad S6E7: Het Gilgamesj-Epos | Tablet VII - De Dood.",
      "nl": "PDF-document voor Eigen Pad S6E7: Het Gilgamesj-Epos | Tablet VII - De Dood.",
      "pap": "Dokumento PDF pa Eigen Pad S6E7: Het Gilgamesj-Epos | Tablet VII - De Dood."
    },
    "url": "./media/s6/het-gilgamesj-epos-s6e7.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-eigen-pad-s6e8-het-gilgamesj-epos-tablet-viii-t-m-xii-de-zoektocht-en-terugkeer-181",
    "title": {
      "en": "Eigen Pad S6E8: The Epic of Gilgamesh | Tablets VIII–XII - The Quest and the Return",
      "es": "Eigen Pad S6E8: La Epopeya de Gilgamesh | Tablillas VIII–XII - La Búsqueda y el Regreso",
      "nl": "Eigen Pad S6E8: Het Gilgamesj-Epos | Tablet VIII t/m XII - De Zoektocht en Terugkeer",
      "pap": "Eigen Pad S6E8: E Epopeya di Gilgamesh | Tablèt VIII–XII - E Buskeda i e Bòlbementu"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Eigen Pad S6E8: Het Gilgamesj-Epos | Tablet VIII t/m XII - De Zoektocht en Terugkeer.",
      "es": "Documento PDF para Eigen Pad S6E8: Het Gilgamesj-Epos | Tablet VIII t/m XII - De Zoektocht en Terugkeer.",
      "nl": "PDF-document voor Eigen Pad S6E8: Het Gilgamesj-Epos | Tablet VIII t/m XII - De Zoektocht en Terugkeer.",
      "pap": "Dokumento PDF pa Eigen Pad S6E8: Het Gilgamesj-Epos | Tablet VIII t/m XII - De Zoektocht en Terugkeer."
    },
    "url": "./media/s6/het-gilgamesj-epos-s6e8.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-pika-pika-talkshow-kiko-pabo-ta-sekta-sataniko-182",
    "title": {
      "en": "Pika Pika Talkshow - What Is a Satanic Cult to You?",
      "es": "Pika Pika Talkshow - ¿Qué Es para Ti una Secta Satánica?",
      "nl": "Pika Pika Talkshow - Wat Is Een Satanische Sekte Voor Jou?",
      "pap": "Pika Pika Talkshow - Kiko pabo ta sekta sataniko?"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Pika Pika Talkshow - Kiko pabo ta sekta sataniko?.",
      "es": "Documento PDF para Pika Pika Talkshow - Kiko pabo ta sekta sataniko?.",
      "nl": "PDF-document voor Pika Pika Talkshow - Kiko pabo ta sekta sataniko?.",
      "pap": "Dokumento PDF pa Pika Pika Talkshow - Kiko pabo ta sekta sataniko?."
    },
    "url": "./media/de-facto-satanism.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-nothing-new-under-the-sun-interviewed-by-jonathan-wright-english-183",
    "title": {
      "en": "Nothing New Under The Sun - Interviewed by Jonathan Wright (English)",
      "es": "Nothing New Under The Sun - Entrevistado por Jonathan Wright (inglés)",
      "nl": "Nothing New Under The Sun - Geïnterviewd door Jonathan Wright (Engels)",
      "pap": "Nothing New Under The Sun - Entrevistá pa Jonathan Wright (ingles)"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Nothing New Under The Sun - Interviewed by Jonathan Wright (English).",
      "es": "Documento PDF para Nothing New Under The Sun - Interviewed by Jonathan Wright (English).",
      "nl": "PDF-document voor Nothing New Under The Sun - Interviewed by Jonathan Wright (English).",
      "pap": "Dokumento PDF pa Nothing New Under The Sun - Interviewed by Jonathan Wright (English)."
    },
    "url": "/media/Kybalion.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-season-02-episode-03-verdeel-and-heers-en-indoctrinatie-technieken-184",
    "title": {
      "en": "Season 02/Episode 03: Divide & Conquer, and Indoctrination Techniques",
      "es": "Temporada 02/Episodio 03: Divide y Vencerás, y Técnicas de Adoctrinamiento",
      "nl": "Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken",
      "pap": "Temporada 02/Episodio 03: Dividí i Vense, i Teknikanan di Indoktrinashon"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken.",
      "es": "Documento PDF para Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken.",
      "nl": "PDF-document voor Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken.",
      "pap": "Dokumento PDF pa Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken."
    },
    "url": "./articles/machiavelli-the-art-of-war.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-season-02-episode-03-verdeel-and-heers-en-indoctrinatie-technieken-185",
    "title": {
      "en": "Season 02/Episode 03: Divide & Conquer, and Indoctrination Techniques",
      "es": "Temporada 02/Episodio 03: Divide y Vencerás, y Técnicas de Adoctrinamiento",
      "nl": "Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken",
      "pap": "Temporada 02/Episodio 03: Dividí i Vense, i Teknikanan di Indoktrinashon"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken.",
      "es": "Documento PDF para Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken.",
      "nl": "PDF-document voor Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken.",
      "pap": "Dokumento PDF pa Season 02/Episode 03: Verdeel & Heers, en Indoctrinatie Technieken."
    },
    "url": "./articles/sun tzu-the-art-of-war.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-season-02-karmishe-wet-of-niet-186",
    "title": {
      "en": "Season 02/ Karmic Law (or Not)",
      "es": "Temporada 02/ La Ley Kármica (o No)",
      "nl": "Season 02/ Karmishe Wet (of Niet)",
      "pap": "Temporada 02/ Lei Kármiko (òf Nò)"
    },
    "type": "pdf",
    "language": "en",
    "availableLanguages": [
      "en"
    ],
    "description": {
      "en": "PDF document for Season 02/ Karmishe Wet (of Niet).",
      "es": "Documento PDF para Season 02/ Karmishe Wet (of Niet).",
      "nl": "PDF-document voor Season 02/ Karmishe Wet (of Niet).",
      "pap": "Dokumento PDF pa Season 02/ Karmishe Wet (of Niet)."
    },
    "url": "./articles/TheTeachingofBuddha.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-season-02-episode-08-medicijn-187",
    "title": {
      "en": "Season 02/Episode 08: Medicine",
      "es": "Temporada 02/Episodio 08: Medicina",
      "nl": "Season 02/Episode 08: Medicijn",
      "pap": "Temporada 02/Episodio 08: Remedi"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Season 02/Episode 08: Medicijn.",
      "es": "Documento PDF para Season 02/Episode 08: Medicijn.",
      "nl": "PDF-document voor Season 02/Episode 08: Medicijn.",
      "pap": "Dokumento PDF pa Season 02/Episode 08: Medicijn."
    },
    "url": "./media/vaccinvrij-boek.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-season-02-episode-11-religie-deel-1-188",
    "title": {
      "en": "Season 02/Episode 11: Religion - Part 1",
      "es": "Temporada 02/Episodio 11: Religión - Parte 1",
      "nl": "Season 02/Episode 11: Religie - Deel 1",
      "pap": "Temporada 02/Episodio 11: Religion - Parti 1"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Season 02/Episode 11: Religie - Deel 1.",
      "es": "Documento PDF para Season 02/Episode 11: Religie - Deel 1.",
      "nl": "PDF-document voor Season 02/Episode 11: Religie - Deel 1.",
      "pap": "Dokumento PDF pa Season 02/Episode 11: Religie - Deel 1."
    },
    "url": "./articles/Pre-Existing-Data-Christianized-NL.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-season-02-episode-11-religie-deel-1-189",
    "title": {
      "en": "Season 02/Episode 11: Religion - Part 1",
      "es": "Temporada 02/Episodio 11: Religión - Parte 1",
      "nl": "Season 02/Episode 11: Religie - Deel 1",
      "pap": "Temporada 02/Episodio 11: Religion - Parti 1"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Season 02/Episode 11: Religie - Deel 1.",
      "es": "Documento PDF para Season 02/Episode 11: Religie - Deel 1.",
      "nl": "PDF-document voor Season 02/Episode 11: Religie - Deel 1.",
      "pap": "Dokumento PDF pa Season 02/Episode 11: Religie - Deel 1."
    },
    "url": "./articles/Parallels-Between-Jesus-And-Horus-NL.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-season-02-episode-11-religie-deel-1-190",
    "title": {
      "en": "Season 02/Episode 11: Religion - Part 1",
      "es": "Temporada 02/Episodio 11: Religión - Parte 1",
      "nl": "Season 02/Episode 11: Religie - Deel 1",
      "pap": "Temporada 02/Episodio 11: Religion - Parti 1"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Season 02/Episode 11: Religie - Deel 1.",
      "es": "Documento PDF para Season 02/Episode 11: Religie - Deel 1.",
      "nl": "PDF-document voor Season 02/Episode 11: Religie - Deel 1.",
      "pap": "Dokumento PDF pa Season 02/Episode 11: Religie - Deel 1."
    },
    "url": "./media/protocols.pdf",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit-191",
    "title": {
      "en": "Season 01/Episode 07: The Path to Real Freedom and Sovereignty",
      "es": "Temporada 01/Episodio 07: El Camino hacia la Verdadera Libertad y Soberanía",
      "nl": "Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit",
      "pap": "Temporada 01/Episodio 07: E Kaminda pa Berdadero Libertat i Soberania"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit.",
      "es": "Documento PDF para Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit.",
      "nl": "PDF-document voor Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit.",
      "pap": "Dokumento PDF pa Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit."
    },
    "url": "./articles/AquinasOverVrijheid.pdf#toolbar=0",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  },
  {
    "id": "legacy-season-01-episode-07-de-weg-naar-echte-vrijheid-en-soevereiniteit-2-192",
    "title": {
      "en": "Season 01/Episode 07: The Path to Real Freedom and Sovereignty",
      "es": "Temporada 01/Episodio 07: El Camino hacia la Verdadera Libertad y Soberanía",
      "nl": "Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit",
      "pap": "Temporada 01/Episodio 07: E Kaminda pa Berdadero Libertat i Soberania"
    },
    "type": "pdf",
    "language": "nl",
    "availableLanguages": [
      "nl"
    ],
    "description": {
      "en": "PDF document for Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit.",
      "es": "Documento PDF para Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit.",
      "nl": "PDF-document voor Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit.",
      "pap": "Dokumento PDF pa Season 01/Episode 07: De Weg naar Echte Vrijheid en Soevereiniteit."
    },
    "url": "./articles/AquinasOnLiberty.pdf#toolbar=0",
    "category": "media",
    "relatedProgram": "legacy-media-archive",
    "relatedCourse": null
  }
];
